// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-11-03T22:58:20.678Z
// Property: Sheridan Ridge Townhomes (ID: 6767906449167609)
// Collections: 19 amenities, 7 floorplans (live), 35 photos, 74 POIs, 3 reviews, 4 virtual tours, 6 office hours, 16 faqs
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162465",
  "multihub_property_id": "6767906449167609",
  "property_external_id": "1124183",
  "property_zillow_url": null,
  "property_apartments_url": "https://www.apartments.com/sheridan-ridge-townhomes-overland-park-ks/nw5ym7p/",
  "property_google_business_url": "https://www.google.com/maps/place/Sheridan+Ridge+Townhomes/@38.9769671,-94.6971494,769m/data=!3m2!1e3!4b1!4m6!3m5!1s0x87c0eb62b3ec69ed:0xec165131ca1807f3!8m2!3d38.9769671!4d-94.6971494!16s%2Fg%2F1vp74932?entry=ttu&g_ep=EgoyMDI2MDkxNi4wIKXMDSoASAFQAw%3D%3D",
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": "RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": "1124183 p1099135",
  "property_status": null,
  "property_slug": "sheridan-ridge-townhomes",
  "property_name": "Sheridan Ridge Townhomes",
  "property_website_url": "https://www.sheridanridgeapts.com/",
  "property_domain": "https://www.sheridanridgeapts.com/",
  "property_address": "8403 Carter Dr",
  "property_full_address": "8403 Carter Dr, Overland Park, KS 66212",
  "property_address_1": "8403 Carter Dr",
  "property_address_2": null,
  "property_address_city": "Overland Park",
  "property_address_state": "KS",
  "property_address_zip_full": null,
  "property_address_zip": "66212",
  "property_address_country": "US",
  "property_address_county": "Johnson County",
  "property_neighborhood_address": "Concorde Bridge",
  "property_address_latitude": "38.9768324",
  "property_address_longitude": "-94.6966358",
  "property_email": "rentcafe.sr@pricekc.com",
  "property_phone": "(913) 349-7174",
  "property_call_tracking_phone": "913-349-7174",
  "property_company_name": "Price Brothers",
  "property_company_url": "https://www.pricebrotherskc.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "<p><strong>Room to spread out, minutes from Overland Park favorites.</strong> Sheridan Ridge Townhomes offers spacious two- and three-bedroom layouts with finished basements, generous closets, private patios, and easy everyday convenience just off I-35—explore your next townhome today.</p>",
  "property_long_description": "<p><strong>Room to spread out, minutes from the best of Overland Park.</strong> Sheridan Ridge Townhomes pairs two- and three-bedroom townhome-style layouts with everyday convenience in Concorde Bridge, just off I-35 near 85th and Farley. Inside, you can enjoy a finished basement, washer/dryer connections, an electric range with self-cleaning oven, generous closets, and a private patio, with fireplaces and renovated finishes available in select homes.</p><p>Beyond your front door, <a href=\"/amenities\">community amenities</a> make the day easier: a fitness center, clubhouse, business center, pool, volleyball court, carports, package service, and on-site management and maintenance. When it’s time to get out, you’re close to Sapling Grove Park, quick shopping and dining along 87th Street and Metcalf Avenue, and the local restaurants, arts, and Farmers’ Market energy of Downtown Overland Park. Explore the <a href=\"/floor-plans\">spacious townhome layouts</a> and see how Sheridan Ridge brings comfort, storage, and connected Overland Park living together.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/01a0b65e-a136-72ec-b3f5-ce48c742ae31.webp",
  "property_featured_image_media": {
    "alt_text": "Sheridan Ridge Townhomes monument sign with landscaping.",
    "public_id": "01a0b65e-a136-72ec-b3f5-ce48c742ae31",
    "storage_key": "property/6767906449167609/01a0b65e-a136-72ec-b3f5-ce48c742ae31.webp",
    "width": 1200,
    "height": 800
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "248",
  "property_year_built": "1969",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "94.35483870967742",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": "Deposit: $375",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "300",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "25",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "Restrictions: Aggressive dog breeds including, but not limited to, Pit Bull, American Staffordshire Terrier, Rottweiler, German Shepherd, Malamute, Doberman Pinscher, Chow, Great Dane, Saint Bernard, Akita, Wolf Hybrid, and any mixed breed that includes the aforementioned, are specifically prohibited and Landlord has discretion to limit other breeds. Inherently dangerous or exotic, feral or wild animals are prohibited.",
  "property_pet_policy_description": "The non-refundable fee is $300 for 1 pet, and $500 for 2 pets.",
  "property_petpolicy_info": "https://www.pricebrotherskc.com/petroyaltyclub/",
  "property_online_leasing_url": "https://sheridanridgeapts.securecafeapplicant.com/onlineleasing/content3/access/sheridan-ridge/floorplans",
  "property_resident_portal_url": "https://sheridanridgeapts.securecafe.com/residentservices/sheridan-ridge/userlogin.aspx",
  "property_apply_now_url": "https://sheridanridgeapts.securecafeapplicant.com/onlineleasing/content3/access/sheridan-ridge/login",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/019fc986-6909-73fe-9246-1722d972164b.webp",
  "property_primary_logo_media": {
    "alt_text": "Sheridan Ridge Townhomes logo",
    "public_id": "019fc986-6909-73fe-9246-1722d972164b",
    "storage_key": "property/6767906449167609/019fc986-6909-73fe-9246-1722d972164b.webp",
    "width": 533,
    "height": 150
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/019fc987-87bf-7578-bd50-4bb256a523e3.webp",
  "property_mono_white_logo_media": {
    "alt_text": null,
    "public_id": "019fc987-87bf-7578-bd50-4bb256a523e3",
    "storage_key": "property/6767906449167609/019fc987-87bf-7578-bd50-4bb256a523e3.webp",
    "width": 533,
    "height": 150
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/019fc987-211c-762a-9a60-59de680ad600.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "019fc987-211c-762a-9a60-59de680ad600",
    "storage_key": "property/6767906449167609/019fc987-211c-762a-9a60-59de680ad600.webp",
    "width": 533,
    "height": 150
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/01a0d9b7-62d2-753a-a137-bd690ff6733b.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/019ff682-589f-76db-bc7c-d7916fa7e182.webp",
  "property_company_logo_media": null,
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/019ff68a-de80-741a-9687-3e84c8c517e3.webp",
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/019ff682-589f-76db-bc7c-d7916fa7e182.webp",
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#00783F",
  "property_secondary_color": "#64513D",
  "property_font_color": null,
  "property_color_4": "#ECAA00",
  "property_color_3": "#A49483",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "2 - 3",
  "property_bedrooms_min": "2",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1.5 - 2.5",
  "property_bathrooms_min": "1.5",
  "property_bathrooms_max": "2.5",
  "property_sqft_range": "1410 - 2054",
  "property_sqft_min": "1410",
  "property_sqft_max": "2054",
  "property_price_range": "1779 - 6585",
  "property_price_min": "1779",
  "property_price_max": "6585",
  "property_available_units": 13,
  "property_facebook_url": "https://www.facebook.com/SheridanRidgeApts",
  "property_instagram_url": "https://www.instagram.com/sheridanridgeapts/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJ7Wnss2LrwIcR8wcYyjFRFuw",
  "property_youtube_url": "https://www.youtube.com/user/Pricebrothersmgt",
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Sheridan Ridge Townhomes",
  "property_home_romance_title": "Experience True Comfort in Your New Apartment Home",
  "property_home_amenities_blurb": "<p><strong>More room to live, more ways to unwind.</strong> Sheridan Ridge Townhomes pairs townhome-style comfort with everyday convenience, from finished basements and fenced patios with BBQ space to washer/dryer connections, dishwashers, and self-cleaning electric ranges. Beyond the front door, enjoy two sparkling pools, a wading pool, fitness center, clubhouse, business center, volleyball court, carports, package service, and on-site management—all close to home in Overland Park.</p>",
  "property_home_floorplans_blurb": "<p><strong>Townhome layouts with space where it counts.</strong> Explore two- and three-bedroom floor plans at Sheridan Ridge, with classic and renovated options, finished basements, washer/dryer connections, full kitchens, generous closets, and private patios. Select homes add fireplaces, microwaves, end-unit placement, or walkout access—giving you more ways to match your layout to your day-to-day.</p>",
  "property_home_gallery_blurb": "<p><strong>Preview life at Sheridan Ridge.</strong> Browse bright townhome interiors with vinyl flooring, practical kitchens, inviting living rooms with fireplace character, finished lower levels, and private patios made for fresh air. The gallery also captures the community extras—pool views, fitness space, clubhouse corners, and outdoor areas that bring more dimension to everyday living in Overland Park.</p>",
  "property_home_neighborhood_blurb": "<p><strong>A tucked-away address with Overland Park close at hand.</strong> From Sheridan Ridge, reach the 87th Street and Metcalf corridors for coffee, dining, errands, and cross-town connections. Nearby Sapling Grove Park adds green space and Santa Fe Trail history, while Downtown Overland Park brings market mornings, Strang Hall, local shops, murals, and Thompson Park events into easy reach. Explore the neighborhood to see how connected life here can feel.</p>",
  "property_home_reviews_blurb": "<p><strong>Residents say it best.</strong> Sheridan Ridge Townhomes earns praise for responsive service, a welcoming office team, and spacious Overland Park townhome layouts with standout features like finished basements, fenced patios, clean grounds, and a pet-friendly atmosphere. From helpful maintenance to everyday comfort and value, the reviews offer a clear snapshot of life at Sheridan Ridge—summed up by one resident simply: “Love living here!”</p>",
  "property_neighborhood_blurb": "<p><strong>A tucked-away starting point for everyday Overland Park.</strong> From Sheridan Ridge, Concorde Bridge keeps you close to the 87th Street and Metcalf corridors for errands, coffee runs, dining, and easy cross-town connections. Follow the map to Sapling Grove Park, where Santa Fe Trail history meets open green space, or head into Downtown Overland Park for market mornings at Clock Tower Landing, chef-driven choices at Strang Hall, local shops, murals, and events around Thompson Park. RideKC routes along 87th and Metcalf add another way to move through Johnson County, while Oak Park Mall and the 95th Street corridor keep larger shopping trips within reach. Explore the neighborhood, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see how connected life at Sheridan Ridge can feel.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p><strong>Amenities that add space, ease, and options.</strong> At Sheridan Ridge Townhomes, the extras go beyond the expected—giving you more ways to settle in, recharge, and make the most of home in Overland Park.</p><p>Start with townhome-style comfort: finished basements for bonus space, private fenced patios with room to BBQ, washer/dryer connections, and practical kitchens with a dishwasher and self-cleaning electric range. Select homes add a fireplace or microwave for an added touch of convenience.</p><p>Outside your door, two sparkling pools and a wading pool bring resort-style downtime close to home, while the fitness center, clubhouse, business center, volleyball court, carports, package service, and on-site management help keep everyday routines moving. Browse the <a href=\"/gallery\">photo gallery</a>, then <a href=\"/schedule-a-tour\">schedule a tour</a> to experience the amenities in person.</p>",
  "property_applynow_blurb": "<p><strong>Ready for more room in Overland Park?</strong> Sheridan Ridge Townhomes offers spacious two- and three-bedroom townhome-style layouts with finished basements, washer/dryer connections, generous closets, and private patios. If comfort, storage, and everyday convenience feel like the right fit, start your application online today.</p>",
  "property_contactus_blurb": "<p><strong>Questions? We’re here to help.</strong><br>Contact the Sheridan Ridge Townhomes leasing team for details on our two- and three-bedroom townhome layouts, available features, or directions to our Overland Park community near I-35. Reach out today and let us help you take the next step.</p>",
  "property_faqs_blurb": "<p><strong>Questions about Sheridan Ridge Townhomes?</strong> Start here for quick answers about the community, leasing, spacious two- and three-bedroom layouts, in-home conveniences, and everyday living in Overland Park. If you don’t see what you need, the leasing team is happy to help.</p>",
  "property_floorplans_blurb": "<p><strong>Compare townhome layouts with room to live on every level.</strong> Sheridan Ridge offers two- and three-bedroom floor plans in Overland Park, including classic and renovated options, so you can choose the mix of bedrooms, baths, and finishes that works for your day-to-day.</p><p>Each layout is designed with the practical space renters look for in a townhome: a finished basement, washer/dryer connections, a full kitchen with dishwasher and self-cleaning range, generous closets, and a private patio for a little fresh air at home. Select homes add details like fireplaces, microwaves, end-unit placement, or walkout access from the main or basement level. Browse current availability, compare pricing, and see which floor plan feels right—then explore more <a href=\"/amenities\">in-home features</a> or <a href=\"/schedule-a-tour\">schedule a tour</a>.</p>",
  "property_gallery_blurb": "<p><strong>See the space before you step inside.</strong> The Sheridan Ridge Townhomes photo gallery gives you a closer look at bright townhome interiors, practical kitchens, comfortable living areas, and the extra breathing room that comes with finished lower levels and private patios. As you scroll, picture everyday moments in the details: sunlight across vinyl flooring, a fireplace adding character to the living room, or a quiet patio ready for fresh air.</p><p>Beyond the front door, the photos highlight the community side of Sheridan Ridge—sparkling pool views, fitness space, clubhouse corners, and outdoor areas that add texture to life in Overland Park. Browse the images, explore more <a href=\"/amenities\">community amenities</a>, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see your favorite spaces in person.</p>",
  "property_interactivemap_blurb": "<p><strong>Find your spot in Overland Park.</strong> Use the interactive map to explore available two- and three-bedroom townhomes at Sheridan Ridge, then zoom out to see how Concorde Bridge keeps parks, shopping, dining, and Downtown Overland Park connections close by.</p>",
  "property_pets_blurb": "<p><strong>Bring your pet into townhome living with a little more room to roam.</strong> At Sheridan Ridge Townhomes, cats and dogs are welcome, and your home gives daily routines the space they deserve—from multi-level layouts to a private patio where you can step outside for fresh air between walks.</p><p>On days when you want to stay close, landscaped community spaces make quick outings simple. When you’re ready for a longer adventure, Overland Park offers nearby trails, pet services, and off-leash options for a change of scenery. Explore our <a href=\"/amenities\">pet-friendly amenities</a>, review the policy details below, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see how Sheridan Ridge can fit life with your four-legged companion.</p>",
  "property_referafriend_blurb": "<p><strong>Love the extra room at Sheridan Ridge?</strong> Share it with a friend. Invite them to discover spacious two- and three-bedroom townhome layouts with finished basements, generous closets, private patios, and everyday convenience close to the best of Overland Park.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident Access at Sheridan Ridge.</strong> Take care of the essentials in minutes—pay rent, submit maintenance requests, and manage your account online. It’s a simple way to stay connected to the everyday convenience that makes your townhome-style living easier.</p>",
  "property_reviews_blurb": "<p><strong>See what residents are saying.</strong> As you browse Sheridan Ridge Townhomes reviews, you’ll notice recurring praise for the welcoming office team, helpful maintenance service, and the generous space inside these Overland Park townhomes.</p><p>Residents highlight roomy three-bedroom layouts, finished basements, fenced patios, clean grounds, and a pet-friendly atmosphere, along with staff who listen, follow through, and help make day-to-day living easier. One review sums it up simply: “Love living here!” If you’re comparing comfort, value, and service, these firsthand experiences offer a clear look at what life at Sheridan Ridge can feel like.</p>",
  "property_created_at": "1785792389016",
  "property_scheduletour_blurb": "<p><strong>See the space for yourself.</strong> Tour two- and three-bedroom townhome layouts with room to spread out, including finished basements, generous closets, washer/dryer connections, and private patios. Visit Sheridan Ridge Townhomes and picture everyday convenience just off I-35 in Overland Park.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you — we received your inquiry.</strong><br>Our leasing team will follow up soon with next steps. In the meantime, Sheridan Ridge Townhomes brings together spacious two- and three-bedroom layouts, finished basements, generous closets, private patios, and convenient Overland Park living just off I-35.</p>",
  "property_virtualtours_blurb": "<p><strong>Walk through the layout before you walk through the door.</strong> Explore Sheridan Ridge Townhomes from wherever you are with virtual tours of the Amber, Emerald, Onyx, and Emerald (Renovated) floor plans. Move through townhome-style spaces at your own pace, noticing how the living areas connect, where the finished basement adds usable flexibility, and how a private patio extends the floor plan outdoors.</p><p>Compare a two-bedroom option like Amber or Emerald, take in the extra room of the three-bedroom Onyx, or preview the updated feel of Emerald (Renovated) with its refreshed kitchen finishes. When a tour catches your eye, review current <a href=\"/floor-plans\">floor plan availability</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see Sheridan Ridge in Overland Park in person.</p>",
  "property_copyright": "2026 All Rights Reserved. Sheridan Ridge Townhomes",
  "property_seo_title_home": "Sheridan Ridge Townhomes |  Apartments in Overland Park, KS",
  "property_seo_description_home": "Experience modern living at Sheridan Ridge Townhomes in Overland Park, KS! Enjoy spacious two and three-bedroom layouts, a fitness center, pool, and more.",
  "property_seo_title_floorplans": "Floor Plans | Overland Park, KS Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal space at Sheridan Ridge Townhomes in Overland Park, KS. Choose from spacious two or three-bedroom plans tailored to your lifestyle!",
  "property_seo_title_amenities": "Amenities | Overland Park, KS Apartments for Rent",
  "property_seo_description_amenities": "Discover luxury at Sheridan Ridge Townhomes in Overland Park, KS. Enjoy spacious layouts, on-site amenities, and a vibrant community!",
  "property_seo_title_gallery": "Gallery | Apartments in Overland Park, KS",
  "property_seo_description_gallery": "Picture life at Sheridan Ridge Townhomes in Overland Park, KS! Spacious two- and three-bedroom layouts, fun amenities, and a vibrant community await you!",
  "property_seo_title_virtualtours": "Virtual Tours | Sheridan Ridge Townhomes Apartments",
  "property_seo_description_virtualtours": "Experience Sheridan Ridge Townhomes in Overland Park, KS. Tour our spacious two and three-bedroom layouts virtually and envision your new home today!",
  "property_seo_title_interactivemap": "Interactive Map | Sheridan Ridge Townhomes Apartments",
  "property_seo_description_interactivemap": "Discover your sanctuary at Sheridan Ridge Townhomes in Overland Park, KS! Explore layouts, amenities, and pricing with our interactive map!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Overland Park, KS",
  "property_seo_description_neighborhood": "Uncover local gems near Sheridan Ridge Townhomes in Overland Park, KS. From parks to dining, find your ideal neighborhood vibe and enjoy the best nearby spots!",
  "property_seo_title_contact": "Contact Us | Sheridan Ridge Townhomes",
  "property_seo_description_contact": "Experience modern living at Sheridan Ridge Townhomes in Overland Park, KS. From spacious two & three bedrooms to friendly leasing support, we’re here for you!",
  "property_seo_title_faqs": "FAQs | Apartments in Overland Park, KS",
  "property_seo_description_faqs": "Find answers to your questions about Sheridan Ridge Townhomes in Overland Park. Learn about our amenities, floor plans, and what makes our community unique!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Overland Park, KS",
  "property_seo_description_reviews": "Experience life at Sheridan Ridge Townhomes in Overland Park, KS! Hear from residents about our vibrant community, spacious layouts, and top-notch amenities.",
  "property_seo_title_applynow": "Apply Now | Apartments in Overland Park, KS",
  "property_seo_description_applynow": "Discover spacious living at Sheridan Ridge Townhomes in Overland Park, KS. Enjoy amenities like a pool, fitness center, and flexible rents!",
  "property_seo_title_residentaccess": "Resident Access | Sheridan Ridge Townhomes",
  "property_seo_description_residentaccess": "Log in to your Sheridan Ridge Townhomes resident portal in Overland Park, KS. Manage rent, request maintenance, and stay connected with your community!",
  "property_seo_title_referafriend": "Refer A Friend | Sheridan Ridge Townhomes",
  "property_seo_description_referafriend": "Great friends make great neighbors! Refer a friend to Sheridan Ridge Townhomes in Overland Park, KS, and enjoy the gift of community living together.",
  "property_seo_title_scheduletour": "Schedule a Tour | Sheridan Ridge Townhomes",
  "property_seo_description_scheduletour": "Experience the charm of Sheridan Ridge Townhomes in Overland Park, KS. Schedule a tour today and envision your new home in a vibrant community!",
  "property_seo_title_privacy": "Privacy Policy | Sheridan Ridge Townhomes",
  "property_seo_description_privacy": "At Sheridan Ridge Townhomes in Overland Park, KS, your privacy matters. Learn how we protect your information with our comprehensive privacy policy. View now!",
  "property_seo_title_accessibility": "Website Accessibility | Sheridan Ridge Townhomes",
  "property_seo_description_accessibility": "At Sheridan Ridge Townhomes in Overland Park, KS, we prioritize accessibility and digital inclusion for all residents. Join a community that truly cares!",
  "property_seo_title_sitemap": "Sitemap | Sheridan Ridge Townhomes",
  "property_seo_description_sitemap": "Navigate Sheridan Ridge Townhomes in Overland Park, KS! Our sitemap makes it easy to find the perfect home and amenities you’ll love. Check it out now!",
  "property_seo_title_thankyou": "Thank You | Sheridan Ridge Townhomes",
  "property_seo_description_thankyou": "Thank you for reaching out to Sheridan Ridge Townhomes in Overland Park! Our team will connect soon to help you find your perfect home. Stay tuned!",
  "property_seo_title_pets": "Pet Policy | Apartments in Overland Park, KS",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1793628991353",
  "amenities": [
    {
      "id": "ec_109476052ab852ef332f3d49",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "source": "yardi",
      "external_id": "88045218",
      "title": "Clubhouse",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_644ed29a877b2b65e131199c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "source": "yardi",
      "external_id": "88045220",
      "title": "2 Shimmering Swimming Pools and Wading Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/01a1676c-48fc-73de-b822-0fd9edfbd4d4.webp",
      "amenity_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and apartment buildings in the background.",
        "public_id": "01a1676c-48fc-73de-b822-0fd9edfbd4d4",
        "storage_key": "property/6767906449167609/01a1676c-48fc-73de-b822-0fd9edfbd4d4.webp",
        "width": 1302,
        "height": 868
      },
      "amenity_image_alt_text": "Extensive Resort Inspired Pool Deck at Sheridan Ridge Townhomes Apartments, Overland Park, KS, 66212,Turquoise Swimming Pool at Sheridan Ridge Townhomes Apartments, Kansas, 66212,Swimming Pool With Lounge Chairs at Sheridan Ridge Townhomes Apartments, Kansas,Swimming Pool And Sundeck at Sheridan Ridge Townhomes Apartments, Overland Park,Swimming Pool With Sparkling Water at Sheridan Ridge Townhomes Apartments, Overland Park, Kansas",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_843a956cf77fc67ae96be7d2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "source": "yardi",
      "external_id": "88045215",
      "title": "Business Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/01a0b65e-de36-75c4-bf66-82dd5bb7ca1a.webp",
      "amenity_image_media": {
        "alt_text": "Business center with computers and printer",
        "public_id": "01a0b65e-de36-75c4-bf66-82dd5bb7ca1a",
        "storage_key": "property/6767906449167609/01a0b65e-de36-75c4-bf66-82dd5bb7ca1a.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "a desk with a computer and a printer in a room at Sheridan Ridge Townhomes Apartments, Overland Park, KS",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_18e89f0ba758bd38b8e949eb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "source": "yardi",
      "external_id": "88045217",
      "title": "Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/01a0b65e-ded8-72dd-b732-efbf85721a3b.webp",
      "amenity_image_media": {
        "alt_text": "Fitness center with cardio machines, weight machines, and free weights.",
        "public_id": "01a0b65e-ded8-72dd-b732-efbf85721a3b",
        "storage_key": "property/6767906449167609/01a0b65e-ded8-72dd-b732-efbf85721a3b.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "Fitness center equipment at Sheridan Ridge Townhomes Apartments, Overland Park, Kansas,Fitness center at Sheridan Ridge Townhomes Apartments, Overland Park 66212",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_001070850892dfea8428951c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "source": "yardi",
      "external_id": "88065063",
      "title": "Carports",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4eb6a44bea04a999dc7c5c5d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "source": "yardi",
      "external_id": "128489142",
      "title": "Dog Park",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4e899f0f506f1437104a4b63",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "source": "yardi",
      "external_id": "88065064",
      "title": "Professionally Managed with 24-Hour Emergency Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1b6ba254ffec9d2adc4852f8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "source": "yardi",
      "external_id": "122755392",
      "title": "Flexible Rent Payment Options Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_04e449f4149ee4e48d99fcc5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "source": "yardi",
      "external_id": "88045208",
      "title": "Ceiling Fans",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/01a0b65e-de33-7498-9419-fec7f0ddfb3f.webp",
      "amenity_image_media": {
        "alt_text": "Bedroom with a king-size bed, closet, and ensuite bathroom.",
        "public_id": "01a0b65e-de33-7498-9419-fec7f0ddfb3f",
        "storage_key": "property/6767906449167609/01a0b65e-de33-7498-9419-fec7f0ddfb3f.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "A bedroom with a large bed and a ceiling fan at Sheridan Ridge Townhomes Apartments, Overland Park",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a2f876c2f50487367a5fa1db",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "source": "yardi",
      "external_id": "88045203",
      "title": "Cable Ready",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f25c4dab94682a2975d1c3f7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "source": "yardi",
      "external_id": "88045204",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a2f33fb4c340dc6a2e29cd73",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "source": "yardi",
      "external_id": "88045206",
      "title": "Refrigerator",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_443d76ed477895de328f5b9a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "source": "yardi",
      "external_id": "88045207",
      "title": "Private Patios",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/01a0b65e-dedd-77c4-8ee8-fb3321ce2906.webp",
      "amenity_image_media": {
        "alt_text": "Private patio with outdoor seating and a small table.",
        "public_id": "01a0b65e-dedd-77c4-8ee8-fb3321ce2906",
        "storage_key": "property/6767906449167609/01a0b65e-dedd-77c4-8ee8-fb3321ce2906.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "A modern outdoor patio with a couch, chairs, and a table at Sheridan Ridge Townhomes Apartments, Overland Park, KS, 66212",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b233a5849f4f4d40d9760c73",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "source": "yardi",
      "external_id": "88045209",
      "title": "Microwave*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1b0dbd4774bf342a38f0d00f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "source": "yardi",
      "external_id": "88045210",
      "title": "Fireplace*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/01a0b65e-ea9d-745c-96ac-857ae45e54ba.webp",
      "amenity_image_media": {
        "alt_text": "Living room with fireplace, TV, stairs, and dining area.",
        "public_id": "01a0b65e-ea9d-745c-96ac-857ae45e54ba",
        "storage_key": "property/6767906449167609/01a0b65e-ea9d-745c-96ac-857ae45e54ba.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "A living room with a fireplace and a television at Sheridan Ridge Townhomes Apartments, Kansas",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_979711a046da5f3b8d8b7e51",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "source": "yardi",
      "external_id": "88045213",
      "title": "Washer/Dryer Connections",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/01a0b65e-ec57-719e-b133-3260426ae69b.webp",
      "amenity_image_media": {
        "alt_text": "Laundry room with washer and dryer, shelving unit with folded clothes, and a glimpse of a living area through a doorway.",
        "public_id": "01a0b65e-ec57-719e-b133-3260426ae69b",
        "storage_key": "property/6767906449167609/01a0b65e-ec57-719e-b133-3260426ae69b.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "A laundry room with a washer and dryer at Sheridan Ridge Townhomes Apartments, Overland Park",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6e15e79dc07c240bc384f625",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "source": "yardi",
      "external_id": "88045205",
      "title": "Finished Basement",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/01a0b65e-ed4e-713a-b943-33325060bace.webp",
      "amenity_image_media": {
        "alt_text": "Basement living area with pool table and seating area.",
        "public_id": "01a0b65e-ed4e-713a-b943-33325060bace",
        "storage_key": "property/6767906449167609/01a0b65e-ed4e-713a-b943-33325060bace.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "A pool table is in the middle of a room with a staircase on the right at Sheridan Ridge Townhomes Apartments, Overland Park, Kansas,A living room with a staircase and a television at Sheridan Ridge Townhomes Apartments, Overland Park 66212,A living room with a grey couch, a television, and a bookshelf at Sheridan Ridge Townhomes Apartments, Overland Park, KS",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_382a24c40ac7b28dd33481fc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "source": "yardi",
      "external_id": "88045211",
      "title": "Electric Range with Self Cleaning Oven",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/01a0b65e-edb6-758d-803c-96a38b54d149.webp",
      "amenity_image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and white cabinets.",
        "public_id": "01a0b65e-edb6-758d-803c-96a38b54d149",
        "storage_key": "property/6767906449167609/01a0b65e-edb6-758d-803c-96a38b54d149.webp",
        "width": 1200,
        "height": 799
      },
      "amenity_image_alt_text": "A modern kitchen with white cabinets and stainless steel appliances at Sheridan Ridge Townhomes Apartments, Kansas, 66212,A white kitchen with a black countertop and a stove top oven at Sheridan Ridge Townhomes Apartments, Kansas",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_245609a461a50dbccfc96dad",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "source": "yardi",
      "external_id": "88075922",
      "title": "Ability to BBQ Inside the Private Fenced-In Patio Area",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_eb2dd06837e4c639cf08d983",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/01a0b65e-a136-72ec-b3f5-ce48c742ae31.webp",
      "image_media": {
        "alt_text": "Sheridan Ridge Townhomes monument sign with landscaping.",
        "public_id": "01a0b65e-a136-72ec-b3f5-ce48c742ae31",
        "storage_key": "property/6767906449167609/01a0b65e-a136-72ec-b3f5-ce48c742ae31.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Welcome to Sheridan Ridge Townhomes! Discover your new home at our community. Visit the information center for details.",
      "link": "false",
      "alt_text": "Sheridan Ridge Townhomes monument sign with landscaping.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/1-8403 Carter Dr-16.jpg"
    },
    {
      "id": "ec_d7a5363e20dbff032dbb6c13",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/01a1628f-6ec7-7231-98dc-c774f565729d.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool and hot tub area at an apartment complex during sunset.",
        "public_id": "01a1628f-6ec7-7231-98dc-c774f565729d",
        "storage_key": "property/6767906449167609/01a1628f-6ec7-7231-98dc-c774f565729d.webp",
        "width": 1448,
        "height": 1086
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our stunning outdoor pool or relax in the bubbling hot tub. Perfect for unwinding after a long day or soaking up the sun during warm weather.",
      "link": "false",
      "alt_text": "Resort-style swimming pool and hot tub area at an apartment complex during sunset.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Twilight Clubhouse Pool Retreat.png"
    },
    {
      "id": "ec_31deb0da2516b2cf19e7d037",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/01a1628f-6e6b-75bb-aec3-72e956dc698e.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and a brick building at sunset.",
        "public_id": "01a1628f-6e6b-75bb-aec3-72e956dc698e",
        "storage_key": "property/6767906449167609/01a1628f-6e6b-75bb-aec3-72e956dc698e.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, surrounded by comfortable lounge chairs and lush landscaping. Perfect for relaxing and unwinding.",
      "link": "false",
      "alt_text": "Resort-style swimming pool with lounge chairs and a brick building at sunset.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Twilight Poolside Community Retreat.png"
    },
    {
      "id": "ec_33930e5c1df5fb46941d4959",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/01a1628f-7370-779e-a135-b34264466d11.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and apartment buildings in the background.",
        "public_id": "01a1628f-7370-779e-a135-b34264466d11",
        "storage_key": "property/6767906449167609/01a1628f-7370-779e-a135-b34264466d11.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, surrounded by comfortable lounge chairs for sunbathing and relaxation.",
      "link": "false",
      "alt_text": "Outdoor swimming pool with lounge chairs and apartment buildings in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Sunlit Apartment Community Pool.png"
    },
    {
      "id": "ec_4946b5a86e23f8e47775fab6",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/01a1628f-6e61-75eb-8cfa-b9e2470b56e9.webp",
      "image_media": {
        "alt_text": "Exterior of a multifamily building with two identical front doors and steps leading up to them.",
        "public_id": "01a1628f-6e61-75eb-8cfa-b9e2470b56e9",
        "storage_key": "property/6767906449167609/01a1628f-6e61-75eb-8cfa-b9e2470b56e9.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Community",
      "description": "Charming exterior of a multifamily property featuring two distinct entrances, each with its own set of steps and porch. The building showcases a blend of siding and stone accents.",
      "link": "false",
      "alt_text": "Exterior of a multifamily building with two identical front doors and steps leading up to them.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Symmetrical Landscaped Townhouse Entrance.png"
    },
    {
      "id": "ec_e56d570c964aabd01343c672",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/01a0b65e-fc8b-70ec-bbf7-afd4cfc0bf61.webp",
      "image_media": {
        "alt_text": "Exterior view of townhome buildings with manicured lawns and walkways.",
        "public_id": "01a0b65e-fc8b-70ec-bbf7-afd4cfc0bf61",
        "storage_key": "property/6767906449167609/01a0b65e-fc8b-70ec-bbf7-afd4cfc0bf61.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Charming exterior of townhomes featuring neat landscaping and a welcoming walkway leading to the front door.",
      "link": "false",
      "alt_text": "Exterior view of townhome buildings with manicured lawns and walkways.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/4-8403 Carter Dr-10.jpg"
    },
    {
      "id": "ec_3b8c27c305f6cc14c85ed250",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/01a0b65e-fb56-738e-9ea3-729489f75800.webp",
      "image_media": {
        "alt_text": "Covered parking spaces with unit numbers and green lawn.",
        "public_id": "01a0b65e-fb56-738e-9ea3-729489f75800",
        "storage_key": "property/6767906449167609/01a0b65e-fb56-738e-9ea3-729489f75800.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Covered parking is available for residents, offering protection from the elements.",
      "link": "false",
      "alt_text": "Covered parking spaces with unit numbers and green lawn.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/3-8403 Carter Dr-8.jpg"
    },
    {
      "id": "ec_b975c66c0a7a3d5b8965f583",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/01a1628f-6f22-720e-9277-4c3b2fd91308.webp",
      "image_media": {
        "alt_text": "Living room with a fireplace, TV, and view into the kitchen.",
        "public_id": "01a1628f-6f22-720e-9277-4c3b2fd91308",
        "storage_key": "property/6767906449167609/01a1628f-6f22-720e-9277-4c3b2fd91308.webp",
        "width": 1448,
        "height": 1086
      },
      "title": "Apartment",
      "description": "Cozy living room featuring a fireplace, a mounted TV, and comfortable seating. An entryway opens to the kitchen.",
      "link": "false",
      "alt_text": "Living room with a fireplace, TV, and view into the kitchen.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/ChatGPT Image Oct 21, 2026, 05_30_04 PM-3(1).png"
    },
    {
      "id": "ec_50ca781a8fdb56d0b591e297",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/01a1628f-83c2-76bb-8e30-b51372ec0ca3.webp",
      "image_media": {
        "alt_text": "Cozy living room with fireplace, comfortable sofa, coffee table, and dining area visible through doorway.",
        "public_id": "01a1628f-83c2-76bb-8e30-b51372ec0ca3",
        "storage_key": "property/6767906449167609/01a1628f-83c2-76bb-8e30-b51372ec0ca3.webp",
        "width": 1448,
        "height": 1086
      },
      "title": "Apartment",
      "description": "Experience comfort and style in this inviting living space, featuring a warm fireplace, plush seating, and a dedicated dining area perfect for entertaining.",
      "link": "false",
      "alt_text": "Cozy living room with fireplace, comfortable sofa, coffee table, and dining area visible through doorway.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/ChatGPT Image Oct 21, 2026, 05_30_03 PM-2(1).png"
    },
    {
      "id": "ec_3faf77a274b8216ef6185a21",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/01a1628f-851e-711d-ac09-e173271de96c.webp",
      "image_media": {
        "alt_text": "Bedroom with a large bed, nightstands, and a walk-in closet.",
        "public_id": "01a1628f-851e-711d-ac09-e173271de96c",
        "storage_key": "property/6767906449167609/01a1628f-851e-711d-ac09-e173271de96c.webp",
        "width": 1448,
        "height": 1086
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable king-size bed, elegant nightstands with lamps, and a generous walk-in closet with ample storage space.",
      "link": "false",
      "alt_text": "Bedroom with a large bed, nightstands, and a walk-in closet.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/ChatGPT Image Oct 21, 2026, 05_15_28 PM.png"
    },
    {
      "id": "ec_ff1474db687bc2b7d5d9af87",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/01a1628f-870b-7221-b3c2-e094a5132f5e.webp",
      "image_media": {
        "alt_text": "A well-appointed bedroom with a queen-sized bed, desk, and nightstand.",
        "public_id": "01a1628f-870b-7221-b3c2-e094a5132f5e",
        "storage_key": "property/6767906449167609/01a1628f-870b-7221-b3c2-e094a5132f5e.webp",
        "width": 1448,
        "height": 1086
      },
      "title": "Apartment",
      "description": "This charming bedroom features a comfortable queen-sized bed, a functional desk area, and a cozy nightstand, creating a relaxing and inviting atmosphere.",
      "link": "false",
      "alt_text": "A well-appointed bedroom with a queen-sized bed, desk, and nightstand.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/ChatGPT Image Oct 21, 2026, 05_15_34 PM.png"
    },
    {
      "id": "ec_3f6b616c96e23d10d67e0355",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/01a1628f-8828-71e2-8c7e-a57ed918f515.webp",
      "image_media": {
        "alt_text": "Bedroom with a large bed, dresser, and mirrored closet doors.",
        "public_id": "01a1628f-8828-71e2-8c7e-a57ed918f515",
        "storage_key": "property/6767906449167609/01a1628f-8828-71e2-8c7e-a57ed918f515.webp",
        "width": 1448,
        "height": 1086
      },
      "title": "Apartment",
      "description": "Relax in the spacious bedroom, featuring a comfortable king-sized bed, ample storage with a dresser and mirrored closet, and natural light from the window.",
      "link": "false",
      "alt_text": "Bedroom with a large bed, dresser, and mirrored closet doors.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/ChatGPT Image Oct 21, 2026, 05_15_19 PM.png"
    },
    {
      "id": "ec_09a9ecc576a0c1098284b4a9",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/01a1628f-8822-72c4-99d2-15a53658d2c0.webp",
      "image_media": {
        "alt_text": "Spacious living room with a sectional sofa, coffee table, and a play area for children.",
        "public_id": "01a1628f-8822-72c4-99d2-15a53658d2c0",
        "storage_key": "property/6767906449167609/01a1628f-8822-72c4-99d2-15a53658d2c0.webp",
        "width": 1448,
        "height": 1086
      },
      "title": "Apartment",
      "description": "Relax and unwind in this beautifully appointed living space, complete with a cozy sectional sofa and a dedicated play area for the little ones.",
      "link": "false",
      "alt_text": "Spacious living room with a sectional sofa, coffee table, and a play area for children.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/ChatGPT Image Oct 21, 2026, 05_30_08 PM-7(1).png"
    },
    {
      "id": "ec_8ad6c57fd236754bac294205",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/01a1628f-94a6-7709-b6c0-0988de4568de.webp",
      "image_media": {
        "alt_text": "Living room with a sectional sofa, coffee table, and television.",
        "public_id": "01a1628f-94a6-7709-b6c0-0988de4568de",
        "storage_key": "property/6767906449167609/01a1628f-94a6-7709-b6c0-0988de4568de.webp",
        "width": 1448,
        "height": 1086
      },
      "title": "Apartment",
      "description": "Relax in this spacious living room featuring a comfortable sectional sofa, a stylish coffee table, and a mounted television, perfect for entertaining or a cozy night in.",
      "link": "false",
      "alt_text": "Living room with a sectional sofa, coffee table, and television.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/ChatGPT Image Oct 21, 2026, 05_30_07 PM-6(1).png"
    },
    {
      "id": "ec_e2e99d8ac5edc1cd545c39a8",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/01a1628f-97f9-7021-bf5a-cfadcc7893d6.webp",
      "image_media": {
        "alt_text": "Living room with sectional sofa, coffee table, and TV.",
        "public_id": "01a1628f-97f9-7021-bf5a-cfadcc7893d6",
        "storage_key": "property/6767906449167609/01a1628f-97f9-7021-bf5a-cfadcc7893d6.webp",
        "width": 1448,
        "height": 1086
      },
      "title": "Apartment",
      "description": "Spacious living room featuring a comfortable sectional sofa, a wooden coffee table, and a mounted television, perfect for relaxation and entertainment.",
      "link": "false",
      "alt_text": "Living room with sectional sofa, coffee table, and TV.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/ChatGPT Image Oct 21, 2026, 05_30_05 PM-4(1).png"
    },
    {
      "id": "ec_cdc1c06c9dec056cfe02d3d9",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/01a1628f-9906-77d5-aa78-cbab90253771.webp",
      "image_media": {
        "alt_text": "Laundry area with washer and dryer hookups, shelving, and storage bins.",
        "public_id": "01a1628f-9906-77d5-aa78-cbab90253771",
        "storage_key": "property/6767906449167609/01a1628f-9906-77d5-aa78-cbab90253771.webp",
        "width": 1448,
        "height": 1086
      },
      "title": "Apartment",
      "description": "Functional laundry space with hookups for a washer and dryer, offering ample storage with shelving and bins. Note: Washer & dryer not included in rental.",
      "link": "false",
      "alt_text": "Laundry area with washer and dryer hookups, shelving, and storage bins.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Organized Basement Laundry Room.png"
    },
    {
      "id": "ec_958882acec36e00516581b88",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/01a1628f-9ef0-743d-b8f3-139fe2009fd4.webp",
      "image_media": {
        "alt_text": "Private patio with sectional sofa, coffee table, and grill.",
        "public_id": "01a1628f-9ef0-743d-b8f3-139fe2009fd4",
        "storage_key": "property/6767906449167609/01a1628f-9ef0-743d-b8f3-139fe2009fd4.webp",
        "width": 1448,
        "height": 1086
      },
      "title": "Apartment",
      "description": "Enjoy outdoor living on your private patio, complete with comfortable seating and a grill for entertaining.",
      "link": "false",
      "alt_text": "Private patio with sectional sofa, coffee table, and grill.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Sunlit Cozy Patio Retreat.png"
    },
    {
      "id": "ec_071d47b4aec1b54c93c58fe9",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/01a0b65f-1c9d-735e-9741-be1fb813d74a.webp",
      "image_media": {
        "alt_text": "Spacious living room and dining area with stairs leading upstairs, featuring modern furniture and decor.",
        "public_id": "01a0b65f-1c9d-735e-9741-be1fb813d74a",
        "storage_key": "property/6767906449167609/01a0b65f-1c9d-735e-9741-be1fb813d74a.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Bright and airy living room with a dining area. This open-concept space features plush seating, a stylish coffee table, and convenient access to stairs.",
      "link": "false",
      "alt_text": "Spacious living room and dining area with stairs leading upstairs, featuring modern furniture and decor.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/09-DSC08051_final.jpg"
    },
    {
      "id": "ec_f2147c0c7008dfd643e31bd9",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/01a0b65f-1d03-73d9-bcfc-71dc96c6282a.webp",
      "image_media": {
        "alt_text": "Kitchen with white cabinets, white appliances including a stove and oven, and a double sink.",
        "public_id": "01a0b65f-1d03-73d9-bcfc-71dc96c6282a",
        "storage_key": "property/6767906449167609/01a0b65f-1d03-73d9-bcfc-71dc96c6282a.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "A bright and functional kitchen featuring white cabinetry, a full-size stove and oven, and a spacious double sink, perfect for everyday cooking and meal preparation.",
      "link": "false",
      "alt_text": "Kitchen with white cabinets, white appliances including a stove and oven, and a double sink.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/04-DSC08011_final.jpg"
    },
    {
      "id": "ec_4f383c31921dd4eced1de48e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/01a0b65f-0995-75d8-abe7-99ed1d3a6360.webp",
      "image_media": {
        "alt_text": "Spacious living room with a sectional sofa, coffee table, and entertainment center with a TV.",
        "public_id": "01a0b65f-0995-75d8-abe7-99ed1d3a6360",
        "storage_key": "property/6767906449167609/01a0b65f-0995-75d8-abe7-99ed1d3a6360.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "This inviting living room features a comfortable sectional sofa, a modern coffee table, and a sleek entertainment center, perfect for relaxing and entertaining.",
      "link": "false",
      "alt_text": "Spacious living room with a sectional sofa, coffee table, and entertainment center with a TV.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/18-DSC08172_final.jpg"
    },
    {
      "id": "ec_5bed033fa1fb7b293fa3d70e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/01a0b65f-0cfa-7635-9aae-eeea36f6c95f.webp",
      "image_media": {
        "alt_text": "Kitchen with white cabinets and a white refrigerator, leading to a dining area with a glass table.",
        "public_id": "01a0b65f-0cfa-7635-9aae-eeea36f6c95f",
        "storage_key": "property/6767906449167609/01a0b65f-0cfa-7635-9aae-eeea36f6c95f.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Compact kitchen featuring white cabinetry, a white refrigerator, and a granite-look countertop. The space opens to a dining area with a modern glass-top table and chairs.",
      "link": "false",
      "alt_text": "Kitchen with white cabinets and a white refrigerator, leading to a dining area with a glass table.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/05-DSC08021_final.jpg"
    },
    {
      "id": "ec_9897294d911d045579485c8c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/01a0b65f-0e00-760d-a661-dfb4c11d9a78.webp",
      "image_media": {
        "alt_text": "Spacious living room with large sectional sofa, coffee table, TV, and bookshelf.",
        "public_id": "01a0b65f-0e00-760d-a661-dfb4c11d9a78",
        "storage_key": "property/6767906449167609/01a0b65f-0e00-760d-a661-dfb4c11d9a78.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Relax and unwind in this beautifully appointed living room, perfect for entertaining or quiet evenings.",
      "link": "false",
      "alt_text": "Spacious living room with large sectional sofa, coffee table, TV, and bookshelf.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/19-DSC08187_final.jpg"
    },
    {
      "id": "ec_abb9bfc6dafc464669063fc9",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/01a0b65f-2c76-7349-89fd-d598a468f8d1.webp",
      "image_media": {
        "alt_text": "Bedroom with a large bed, closet with clothes, and abstract wall art.",
        "public_id": "01a0b65f-2c76-7349-89fd-d598a468f8d1",
        "storage_key": "property/6767906449167609/01a0b65f-2c76-7349-89fd-d598a468f8d1.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable bed, ample closet space, and modern decor. Perfect for relaxation and organization.",
      "link": "false",
      "alt_text": "Bedroom with a large bed, closet with clothes, and abstract wall art.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/13-DSC08082_final.jpg"
    },
    {
      "id": "ec_c196ed7569287dc071b53783",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/01a0b65f-16b1-76cd-b78b-03a8947f3005.webp",
      "image_media": {
        "alt_text": "Clean bathroom with white vanity, toilet, and bathtub with a patterned shower curtain.",
        "public_id": "01a0b65f-16b1-76cd-b78b-03a8947f3005",
        "storage_key": "property/6767906449167609/01a0b65f-16b1-76cd-b78b-03a8947f3005.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Bright and clean bathroom featuring a white vanity, toilet, and a bathtub with a stylish shower curtain. Perfect for relaxation and daily routines.",
      "link": "false",
      "alt_text": "Clean bathroom with white vanity, toilet, and bathtub with a patterned shower curtain.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/16-DSC08157_final.jpg"
    },
    {
      "id": "ec_4051e1376f34a5bf439e895e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/01a0b65f-2c92-7248-84f2-d71aa830c47e.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, nightstands, and a dresser.",
        "public_id": "01a0b65f-2c92-7248-84f2-d71aa830c47e",
        "storage_key": "property/6767906449167609/01a0b65f-2c92-7248-84f2-d71aa830c47e.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable king-size bed, elegant nightstands, and a modern dresser. This room offers a serene retreat.",
      "link": "false",
      "alt_text": "Bedroom with a king-size bed, nightstands, and a dresser.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/12-DSC08066_final.jpg"
    },
    {
      "id": "ec_231e5f99c896e9dca1954327",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/01a0b65f-1fbf-736c-a660-675ef50f53cf.webp",
      "image_media": {
        "alt_text": "Bathroom vanity with a sink, mirror, and towel bar.",
        "public_id": "01a0b65f-1fbf-736c-a660-675ef50f53cf",
        "storage_key": "property/6767906449167609/01a0b65f-1fbf-736c-a660-675ef50f53cf.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Bright and clean bathroom featuring a vanity with a white sink, marble countertop, and a decorative mirror. Includes a towel bar and toilet paper holder.",
      "link": "false",
      "alt_text": "Bathroom vanity with a sink, mirror, and towel bar.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/07-DSC08031.jpg"
    },
    {
      "id": "ec_bb1dd7d0999fec96d55dfa05",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/019fc986-88ab-74ed-9258-887f86bc940c.webp",
      "image_media": {
        "alt_text": "Bedroom with multiple closet doors and a view into a hallway with stairs.",
        "public_id": "019fc986-88ab-74ed-9258-887f86bc940c",
        "storage_key": "property/6767906449167609/019fc986-88ab-74ed-9258-887f86bc940c.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring ample closet storage and a glimpse into a hallway leading to stairs. This room offers a comfortable and functional living space.",
      "link": "false",
      "alt_text": "Bedroom with multiple closet doors and a view into a hallway with stairs.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/14-DSC08117_final.jpg"
    },
    {
      "id": "ec_8064dc68927ca4bad1a6abb1",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/01a0b65f-3c08-73cb-a7a3-a7e4c8ee5b57.webp",
      "image_media": {
        "alt_text": "Bathroom vanity with sink, mirror, and towel bars.",
        "public_id": "01a0b65f-3c08-73cb-a7a3-a7e4c8ee5b57",
        "storage_key": "property/6767906449167609/01a0b65f-3c08-73cb-a7a3-a7e4c8ee5b57.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "A bright and clean bathroom vanity featuring a sink, a decorative mirror, and convenient towel bars.",
      "link": "false",
      "alt_text": "Bathroom vanity with sink, mirror, and towel bars.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/15-DSC08142.jpg"
    },
    {
      "id": "ec_49f65168dd7a3ef703f7e650",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/01a0b65f-2b38-7389-b7ce-f26cc1eca67b.webp",
      "image_media": {
        "alt_text": "Gym with weight machines, treadmills, and free weights.",
        "public_id": "01a0b65f-2b38-7389-b7ce-f26cc1eca67b",
        "storage_key": "property/6767906449167609/01a0b65f-2b38-7389-b7ce-f26cc1eca67b.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Stay active in our fully-equipped fitness center, featuring cardio machines and weight-training equipment.",
      "link": "false",
      "alt_text": "Gym with weight machines, treadmills, and free weights.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/01-DSC07942.jpg"
    },
    {
      "id": "ec_a759de2366547fd2a2970f36",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/01a0b65f-3705-77da-bd3e-d8961bd0e0b4.webp",
      "image_media": {
        "alt_text": "Fitness center with cardio machines, weight machines, and free weights.",
        "public_id": "01a0b65f-3705-77da-bd3e-d8961bd0e0b4",
        "storage_key": "property/6767906449167609/01a0b65f-3705-77da-bd3e-d8961bd0e0b4.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Stay active and energized in our fully-equipped fitness center, featuring a variety of cardio equipment, strength training machines, and free weights.",
      "link": "false",
      "alt_text": "Fitness center with cardio machines, weight machines, and free weights.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/02-DSC07972.jpg"
    },
    {
      "id": "ec_4ea02e2ee9b47912ac52959e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/01a0b65f-3868-71fa-a056-50c5aeaece15.webp",
      "image_media": {
        "alt_text": "Business center with computer, printer, and desk.",
        "public_id": "01a0b65f-3868-71fa-a056-50c5aeaece15",
        "storage_key": "property/6767906449167609/01a0b65f-3868-71fa-a056-50c5aeaece15.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Utilize the convenient business center, equipped with computers and a printer for all your work needs.",
      "link": "false",
      "alt_text": "Business center with computer, printer, and desk.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/03-DSC07982_final.jpg"
    },
    {
      "id": "ec_f90e584d40d90b1d59309bc5",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/01a0b65f-5784-7409-ade8-9932cceaad05.webp",
      "image_media": {
        "alt_text": "Basement recreation room with a pool table and seating area.",
        "public_id": "01a0b65f-5784-7409-ade8-9932cceaad05",
        "storage_key": "property/6767906449167609/01a0b65f-5784-7409-ade8-9932cceaad05.webp",
        "width": 3000,
        "height": 2000
      },
      "title": "Apartment",
      "description": "Enjoy leisure time in this spacious basement recreation room, complete with a pool table and a comfortable seating area. Perfect for entertaining guests.",
      "link": "false",
      "alt_text": "Basement recreation room with a pool table and seating area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/29-8403 Carter Dr-3.jpg"
    },
    {
      "id": "ec_242c1ea184ea96d525583562",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/01a0b65f-4428-7408-8bc4-f27d82ce1bb3.webp",
      "image_media": {
        "alt_text": "Living room with a pool table and couch.",
        "public_id": "01a0b65f-4428-7408-8bc4-f27d82ce1bb3",
        "storage_key": "property/6767906449167609/01a0b65f-4428-7408-8bc4-f27d82ce1bb3.webp",
        "width": 3000,
        "height": 2000
      },
      "title": "Apartment",
      "description": "Enjoy this spacious living area, perfect for entertaining or relaxing, complete with a pool table and comfortable seating.",
      "link": "false",
      "alt_text": "Living room with a pool table and couch.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/21-8403 Carter Dr-4.jpg"
    },
    {
      "id": "ec_221a76b72ae8b3164727324b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/01a0b65f-4be6-767c-8edf-a2e3b4e48ecc.webp",
      "image_media": {
        "alt_text": "In-unit laundry room with washer, dryer, and shelving",
        "public_id": "01a0b65f-4be6-767c-8edf-a2e3b4e48ecc",
        "storage_key": "property/6767906449167609/01a0b65f-4be6-767c-8edf-a2e3b4e48ecc.webp",
        "width": 3000,
        "height": 2000
      },
      "title": "Apartment",
      "description": "Convenient in-unit laundry with modern washer and dryer, plus ample shelving for storage. Easy access from the living area.",
      "link": "false",
      "alt_text": "In-unit laundry room with washer, dryer, and shelving",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/23-8403 Carter Dr-1.jpg"
    },
    {
      "id": "ec_a2c0271d96f385417f631c61",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/01a0b65f-4e9d-74bd-ac71-3ea99403a817.webp",
      "image_media": {
        "alt_text": "Private patio with outdoor seating and a fence.",
        "public_id": "01a0b65f-4e9d-74bd-ac71-3ea99403a817",
        "storage_key": "property/6767906449167609/01a0b65f-4e9d-74bd-ac71-3ea99403a817.webp",
        "width": 3000,
        "height": 2000
      },
      "title": "Community",
      "description": "Enjoy your own private patio space, perfect for relaxing outdoors or entertaining guests.",
      "link": "false",
      "alt_text": "Private patio with outdoor seating and a fence.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/38-Carter Twilight-1.jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_00ef3a3c-e751-4e18-acab-07cb8c33b718",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "source": "custom",
      "poi_name": "Strang Hall",
      "poi_type": "Restaurants",
      "poi_address": "7313 W 80th St, Overland Park, KS 66204, USA",
      "poi_short_description": "Industrial-chic food court with diverse eateries & outdoor tables on a grassy lawn.",
      "poi_long_description": "Industrial-chic food court with diverse eateries & outdoor tables on a grassy lawn.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/019ff6ad-af5d-7361-a58d-2a904cba1591.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6ad-af5d-7361-a58d-2a904cba1591",
        "storage_key": "property/6767906449167609/019ff6ad-af5d-7361-a58d-2a904cba1591.webp",
        "width": 1215,
        "height": 911
      },
      "poi_business_url": "https://www.stranghall.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1763956639910195457&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "strang-hall",
      "poi_latitude": "38.983876",
      "poi_longitude": "-94.6706021",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 913-701-7041",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/019fc985-a5cc-704b-a88b-3718738bba01.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc985-a5cc-704b-a88b-3718738bba01",
        "storage_key": "property/6767906449167609/019fc985-a5cc-704b-a88b-3718738bba01.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJl2WgU63twIcRAfEJ2TfVehg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_e9d51436-7404-46c7-a4eb-69ec6898b54d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "source": "custom",
      "poi_name": "Red Kitchen KC",
      "poi_type": "Restaurants",
      "poi_address": "7926 Santa Fe Dr, Overland Park, KS 66204, USA",
      "poi_short_description": "Counter-serve restaurant offering breakfast burritos, tamales, and other Mexican eats in the Phoenix Building.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/01a0b661-04e5-72e8-a72a-fd04ce002db3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b661-04e5-72e8-a72a-fd04ce002db3",
        "storage_key": "property/6767906449167609/01a0b661-04e5-72e8-a72a-fd04ce002db3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://order.toasttab.com/online/red-kitchen-kc",
      "poi_directions_map_url": "https://maps.google.com/?cid=9910957993454580360&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "red-kitchen-kc",
      "poi_latitude": "38.9847698",
      "poi_longitude": "-94.6718806",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 913-232-9742",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/019fc985-a5cc-704b-a88b-3718738bba01.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc985-a5cc-704b-a88b-3718738bba01",
        "storage_key": "property/6767906449167609/019fc985-a5cc-704b-a88b-3718738bba01.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJnS6PQ66VwIcRiLKt18jLiok",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_b898ef19-3e72-4af2-8f32-7994031b2b50",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "source": "custom",
      "poi_name": "AR’S Breakfast & Brunch",
      "poi_type": "Restaurants",
      "poi_address": "8021 Metcalf Ave, Overland Park, KS 66204, USA",
      "poi_short_description": "Family-run breakfast and lunch spot serving omelets, chilaquiles, and other comfort eats, plus drinks.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/01a01010-cf35-73ad-a8ba-1409f87e2084.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01010-cf35-73ad-a8ba-1409f87e2084",
        "storage_key": "property/6767906449167609/01a01010-cf35-73ad-a8ba-1409f87e2084.webp",
        "width": 1280,
        "height": 955
      },
      "poi_business_url": "https://www.arsbrunchkc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5469154009382351433&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ars-breakfast--brunch",
      "poi_latitude": "38.9836492",
      "poi_longitude": "-94.6674343",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 913-258-5703",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/019fc985-a5cc-704b-a88b-3718738bba01.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc985-a5cc-704b-a88b-3718738bba01",
        "storage_key": "property/6767906449167609/019fc985-a5cc-704b-a88b-3718738bba01.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJe0kaFiztwIcRSXIjP5hW5ks",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "breakfast_restaurant"
    },
    {
      "id": "custom_ca2fdfa1-1718-4ef7-8dba-418da65ee917",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "source": "custom",
      "poi_name": "Brew Haha Coffeehouse",
      "poi_type": "Restaurants",
      "poi_address": "10332 Mastin St, Overland Park, KS 66212, USA",
      "poi_short_description": "Casual coffeehouse serving breakfast, lunch, and sweet treats in a cozy space.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/01a0b661-0155-70b8-93ca-d2e8c915d13c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b661-0155-70b8-93ca-d2e8c915d13c",
        "storage_key": "property/6767906449167609/01a0b661-0155-70b8-93ca-d2e8c915d13c.webp",
        "width": 1000,
        "height": 750
      },
      "poi_business_url": "https://brewhahacoffeehouse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17939360192127628825&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "brew-haha-coffeehouse",
      "poi_latitude": "38.9407887",
      "poi_longitude": "-94.7036471",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 913-904-2099",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/019fc98b-c815-7162-ad1a-829755bd402e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98b-c815-7162-ad1a-829755bd402e",
        "storage_key": "property/6767906449167609/019fc98b-c815-7162-ad1a-829755bd402e.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJeXghiUjrwIcRGfaMRQxp9fg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_0626104d-0a30-48ec-b187-c802eb2cee4b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "source": "custom",
      "poi_name": "First Watch",
      "poi_type": "Restaurants",
      "poi_address": "9102 Metcalf Ave Ste a, Overland Park, KS 66212, USA",
      "poi_short_description": "Cafe chain for health-minded breakfast, brunch & lunch options such as omelets, salads & soups.",
      "poi_long_description": "Cafe chain for health-minded breakfast, brunch & lunch options such as omelets, salads & soups.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/01a0b661-0174-760c-b4c6-f0f27c58b518.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b661-0174-760c-b4c6-f0f27c58b518",
        "storage_key": "property/6767906449167609/01a0b661-0174-760c-b4c6-f0f27c58b518.webp",
        "width": 1280,
        "height": 528
      },
      "poi_business_url": "https://www.firstwatch.com/locations/metcalf/?utm_source=gbp-listing&utm_medium=organic&utm_campaign=gbp-listing&utm_content=metcalf",
      "poi_directions_map_url": "https://maps.google.com/?cid=6698968312222769508&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "first-watch",
      "poi_latitude": "38.9631843",
      "poi_longitude": "-94.6681656",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 913-871-5900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/019fc985-a5cc-704b-a88b-3718738bba01.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc985-a5cc-704b-a88b-3718738bba01",
        "storage_key": "property/6767906449167609/019fc985-a5cc-704b-a88b-3718738bba01.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJo3GwG77rwIcRZOGi8y-E91w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "breakfast_restaurant"
    },
    {
      "id": "custom_06903460-6cef-4ea0-8955-107693ff46b6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "source": "custom",
      "poi_name": "Cinzetti's Italian Market",
      "poi_type": "Restaurants",
      "poi_address": "7201 W 91st St, Overland Park, KS 66212, USA",
      "poi_short_description": "Rustic, Tuscan-style setting with multiple stations preparing varied Italian dishes plus a full bar.",
      "poi_long_description": "Rustic, Tuscan-style setting with multiple stations preparing varied Italian dishes plus a full bar.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/019fc989-c66b-73ea-b5c1-92b2a5de3278.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc989-c66b-73ea-b5c1-92b2a5de3278",
        "storage_key": "property/6767906449167609/019fc989-c66b-73ea-b5c1-92b2a5de3278.webp",
        "width": 674,
        "height": 920
      },
      "poi_business_url": "https://www.cinzzettis.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15626736760797270896&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cinzettis-italian-market",
      "poi_latitude": "38.9632118",
      "poi_longitude": "-94.6693863",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 913-642-0101",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/019fc985-a5cc-704b-a88b-3718738bba01.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc985-a5cc-704b-a88b-3718738bba01",
        "storage_key": "property/6767906449167609/019fc985-a5cc-704b-a88b-3718738bba01.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJq9KElpPrwIcRcBPcOUpS3dg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_90a832eb-b573-4d73-9038-1f43d8336ca3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "source": "custom",
      "poi_name": "Johnny Cascone's Italian Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "6863 W 91st St, Overland Park, KS 66212, USA",
      "poi_short_description": "Established, old-school eatery making classic Italian fare such as ravioli & chicken parmigiana.",
      "poi_long_description": "Established, old-school eatery making classic Italian fare such as ravioli & chicken parmigiana.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/01a01010-cf2d-743d-979a-af32e42e7477.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01010-cf2d-743d-979a-af32e42e7477",
        "storage_key": "property/6767906449167609/01a01010-cf2d-743d-979a-af32e42e7477.webp",
        "width": 1200,
        "height": 673
      },
      "poi_business_url": "http://www.johnnycascones.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16309541528158629823&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "johnny-cascones-italian-restaurant",
      "poi_latitude": "38.9636217",
      "poi_longitude": "-94.6653404",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 913-381-6837",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/019fc985-a5cc-704b-a88b-3718738bba01.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc985-a5cc-704b-a88b-3718738bba01",
        "storage_key": "property/6767906449167609/019fc985-a5cc-704b-a88b-3718738bba01.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJj7qEtOzrwIcRv29gs5shV-I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_b378549c-da25-402c-a61c-0b1b8391ed8d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "source": "custom",
      "poi_name": "J. Gilbert's Wood-Fired Steaks & Seafood",
      "poi_type": "Restaurants",
      "poi_address": "8901 Metcalf Ave, Overland Park, KS 66212, USA",
      "poi_short_description": "Fine-dining-style establishment offering classic steakhouse fare, cocktails & a big menu of sides.",
      "poi_long_description": "Fine-dining-style establishment offering classic steakhouse fare, cocktails & a big menu of sides.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/01a0b661-0180-758a-87a9-cd872f72a2ab.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b661-0180-758a-87a9-cd872f72a2ab",
        "storage_key": "property/6767906449167609/01a0b661-0180-758a-87a9-cd872f72a2ab.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.jgilberts.com/location/jgilberts-kansas-city/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15434298553447221834&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "j-gilberts-wood-fired-steaks--seafood",
      "poi_latitude": "38.96726",
      "poi_longitude": "-94.66683",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 913-642-8070",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/019fc985-a5cc-704b-a88b-3718738bba01.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc985-a5cc-704b-a88b-3718738bba01",
        "storage_key": "property/6767906449167609/019fc985-a5cc-704b-a88b-3718738bba01.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJWwakY43rwIcRSgqMi8KkMdY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_def3765b-0e74-45cc-9036-662d00382b5b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "source": "custom",
      "poi_name": "Ricco's Italian Bistro",
      "poi_type": "Restaurants",
      "poi_address": "11801 College Blvd, Overland Park, KS 66210, USA",
      "poi_short_description": "Traditional Italian food & wood-fired pizzas prepared in a quiet setting with a patio lounge.",
      "poi_long_description": "Traditional Italian food & wood-fired pizzas prepared in a quiet setting with a patio lounge.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/01a0b661-016a-77fa-9163-9bd91649ea61.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b661-016a-77fa-9163-9bd91649ea61",
        "storage_key": "property/6767906449167609/01a0b661-016a-77fa-9163-9bd91649ea61.webp",
        "width": 800,
        "height": 800
      },
      "poi_business_url": "http://riccoskc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=26080697992341164&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "riccos-italian-bistro",
      "poi_latitude": "38.9266442",
      "poi_longitude": "-94.7224104",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 913-469-8405",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/019fc985-a5cc-704b-a88b-3718738bba01.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc985-a5cc-704b-a88b-3718738bba01",
        "storage_key": "property/6767906449167609/019fc985-a5cc-704b-a88b-3718738bba01.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9aUv39PqwIcRrOZTs0GoXAA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_ce8eea00-22f2-457b-8a7a-2fe6ee38c92c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "source": "custom",
      "poi_name": "Santa Fe Café",
      "poi_type": "Restaurants",
      "poi_address": "9946 W 87th St, Overland Park, KS 66212, USA",
      "poi_short_description": "Homestyle American breakfast & lunch served in a laid-back setting with country-western decor.",
      "poi_long_description": "Homestyle American breakfast & lunch served in a laid-back setting with country-western decor.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/019ff6ad-b2d1-72ea-8f35-e34468d94341.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6ad-b2d1-72ea-8f35-e34468d94341",
        "storage_key": "property/6767906449167609/019ff6ad-b2d1-72ea-8f35-e34468d94341.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.cafesantafeop.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14156643049744376535&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "santa-fe-caf",
      "poi_latitude": "38.9716847",
      "poi_longitude": "-94.7024618",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 913-648-5402",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/019fc985-a5cc-704b-a88b-3718738bba01.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc985-a5cc-704b-a88b-3718738bba01",
        "storage_key": "property/6767906449167609/019fc985-a5cc-704b-a88b-3718738bba01.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJMZAArWbrwIcR1yIEQNl_dsQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "breakfast_restaurant"
    },
    {
      "id": "custom_f14b9f78-0dbb-4f98-b98e-a5fa0b29d91e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "source": "custom",
      "poi_name": "Meshuggah Bagels",
      "poi_type": "Restaurants",
      "poi_address": "7096 W 105th St, Overland Park, KS 66212, USA",
      "poi_short_description": "NY-style spot for bagel sandwiches (breakfast, lunch, baked-goods), cream cheese and coffee.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/01a0b661-05b2-73f7-aeb8-2aa06d3b0a85.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b661-05b2-73f7-aeb8-2aa06d3b0a85",
        "storage_key": "property/6767906449167609/01a0b661-05b2-73f7-aeb8-2aa06d3b0a85.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.meshuggahbagels.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14603662080076773681&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "meshuggah-bagels",
      "poi_latitude": "38.9388072",
      "poi_longitude": "-94.6662814",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 913-283-8368",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/019fc985-a5cc-704b-a88b-3718738bba01.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc985-a5cc-704b-a88b-3718738bba01",
        "storage_key": "property/6767906449167609/019fc985-a5cc-704b-a88b-3718738bba01.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJiVVqd7XrwIcRMXnRzkmhqso",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bagel_shop"
    },
    {
      "id": "custom_59ef5c9d-5894-47dd-830c-d260f1849e5c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "source": "custom",
      "poi_name": "Black Dog Coffeehouse",
      "poi_type": "Restaurants",
      "poi_address": "12815 W 87th St Pkwy, Lenexa, KS 66215, USA",
      "poi_short_description": "Cozy cafe with a meeting area & free WiFi offering basic & specialty coffee drinks, plus light eats.",
      "poi_long_description": "Cozy cafe with a meeting area & free WiFi offering basic & specialty coffee drinks, plus light eats.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/01a01010-d293-76b5-bfa2-36b0718e3e7d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01010-d293-76b5-bfa2-36b0718e3e7d",
        "storage_key": "property/6767906449167609/01a01010-d293-76b5-bfa2-36b0718e3e7d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://bdcoffeehouse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6894298284460462094&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "black-dog-coffeehouse",
      "poi_latitude": "38.9703342",
      "poi_longitude": "-94.7343619",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 913-495-5515",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/019fc98b-c815-7162-ad1a-829755bd402e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98b-c815-7162-ad1a-829755bd402e",
        "storage_key": "property/6767906449167609/019fc98b-c815-7162-ad1a-829755bd402e.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJW4FqNKmUwIcRDtDZHMN3rV8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cafe"
    },
    {
      "id": "custom_b8614194-ad18-4c35-8737-65bf2d94ef36",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "source": "custom",
      "poi_name": "McLain's Market Overland Park",
      "poi_type": "Restaurants",
      "poi_address": "10695 Roe Ave, Overland Park, KS 66207, USA",
      "poi_short_description": "Open since 1945, this bakery chain serves breakfast & light lunch, plus signature cookies & cakes.",
      "poi_long_description": "Open since 1945, this bakery chain serves breakfast & light lunch, plus signature cookies & cakes.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/01a0b661-0a89-726a-b57b-d43cebac612f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b661-0a89-726a-b57b-d43cebac612f",
        "storage_key": "property/6767906449167609/01a0b661-0a89-726a-b57b-d43cebac612f.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.mclainskc.com/overland-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8897067355057936804&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mclains-market-overland-park",
      "poi_latitude": "38.93522129999999",
      "poi_longitude": "-94.638951",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 7 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 913-242-8222",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/019fc985-a5cc-704b-a88b-3718738bba01.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc985-a5cc-704b-a88b-3718738bba01",
        "storage_key": "property/6767906449167609/019fc985-a5cc-704b-a88b-3718738bba01.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJNemdMYLpwIcRpNnz6J67eHs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_58071296-5d9e-4ba0-a966-cb7c90d2ff3a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "source": "custom",
      "poi_name": "Hy-Vee Grocery Store",
      "poi_type": "Shopping & Retail",
      "poi_address": "8501 W 95th St, Overland Park, KS 66212, USA",
      "poi_short_description": "Supermarket with fresh and organic produce as well as a bakery.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/019fc98a-1d14-77e0-bba2-93287bf7274e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc98a-1d14-77e0-bba2-93287bf7274e",
        "storage_key": "property/6767906449167609/019fc98a-1d14-77e0-bba2-93287bf7274e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.hy-vee.com/stores/detail.aspx?s=128&utm_source=google&utm_medium=organic&utm_campaign=gmb-listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=11669836886695708453&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hy-vee-grocery-store",
      "poi_latitude": "38.955555",
      "poi_longitude": "-94.683945",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 913-894-1983",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/019fc985-a5ca-725c-93ad-b1bb30597d45.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc985-a5ca-725c-93ad-b1bb30597d45",
        "storage_key": "property/6767906449167609/019fc985-a5ca-725c-93ad-b1bb30597d45.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7xEOmOzrwIcRJYc_qtGW86E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_70f68a86-d094-4592-ad40-a52d4b4f65c5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "source": "custom",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "8800 W 95th St, Overland Park, KS 66212, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/019ff6ad-bd04-773e-bc86-5f61a4421a3d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6ad-bd04-773e-bc86-5f61a4421a3d",
        "storage_key": "property/6767906449167609/019ff6ad-bd04-773e-bc86-5f61a4421a3d.webp",
        "width": 1100,
        "height": 743
      },
      "poi_business_url": "https://www.cvs.com/store-locator/overland-park-ks-pharmacies/8800-w-95th-street-overland-park-ks-66212/storeid=8582?WT.mc_id=LS_GOOGLE_RX_8582",
      "poi_directions_map_url": "https://maps.google.com/?cid=12371330973486656191&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "38.95741659999999",
      "poi_longitude": "-94.6872668",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 913-381-8184",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/019fc98b-c814-7312-ad90-ce1a2e842eda.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98b-c814-7312-ad90-ce1a2e842eda",
        "storage_key": "property/6767906449167609/019fc98b-c814-7312-ad90-ce1a2e842eda.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5WqwQ3XrwIcRv6p1afnLr6s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_9654b7bb-0e64-4f90-a711-dd300a54cb5e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "source": "custom",
      "poi_name": "Price Chopper",
      "poi_type": "Shopping & Retail",
      "poi_address": "8686 Antioch Rd, Overland Park, KS 66212, USA",
      "poi_short_description": "Chain grocery store with a pharmacy, deli, florist, and prepared foods, plus a salad bar.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/019ff6ad-c5e6-7611-aa54-d02b427aa220.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6ad-c5e6-7611-aa54-d02b427aa220",
        "storage_key": "property/6767906449167609/019ff6ad-c5e6-7611-aa54-d02b427aa220.webp",
        "width": 1280,
        "height": 813
      },
      "poi_business_url": "https://www.mypricechopper.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16981107298246919055&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "price-chopper",
      "poi_latitude": "38.9717957",
      "poi_longitude": "-94.6874032",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 913-383-2563",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/019fc985-a5ca-725c-93ad-b1bb30597d45.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc985-a5ca-725c-93ad-b1bb30597d45",
        "storage_key": "property/6767906449167609/019fc985-a5ca-725c-93ad-b1bb30597d45.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJI94MtXjrwIcRjwPNNB4Dqes",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_a3f160b8-838c-41fe-8e4c-41f7f90dea28",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "source": "custom",
      "poi_name": "Walmart Neighborhood Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "9000 Metcalf Ave, Overland Park, KS 66212, USA",
      "poi_short_description": "Chain retailer with a vast selection including groceries, apparel, home goods & electronics.",
      "poi_long_description": "Chain retailer with a vast selection including groceries, apparel, home goods & electronics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/019fc989-fd6b-728e-b148-3faf88811394.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc989-fd6b-728e-b148-3faf88811394",
        "storage_key": "property/6767906449167609/019fc989-fd6b-728e-b148-3faf88811394.webp",
        "width": 1280,
        "height": 646
      },
      "poi_business_url": "https://www.walmart.com/store/5207-overland-park-ks/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=12659740443510836108&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-neighborhood-market",
      "poi_latitude": "38.9657193",
      "poi_longitude": "-94.6687907",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 913-649-4335",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/019fc985-a5ca-725c-93ad-b1bb30597d45.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc985-a5ca-725c-93ad-b1bb30597d45",
        "storage_key": "property/6767906449167609/019fc985-a5ca-725c-93ad-b1bb30597d45.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJYWyHUZLrwIcRjAsc9NtusK8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_cbbed2e4-6659-40ef-b8ae-594425e5f6cd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "source": "custom",
      "poi_name": "ALDI",
      "poi_type": "Shopping & Retail",
      "poi_address": "8333 W 95th St, Overland Park, KS 66212, USA",
      "poi_short_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_long_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/019fc98a-0f70-71fd-acc5-15fef80725e8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc98a-0f70-71fd-acc5-15fef80725e8",
        "storage_key": "property/6767906449167609/019fc98a-0f70-71fd-acc5-15fef80725e8.webp",
        "width": 1280,
        "height": 586
      },
      "poi_business_url": "https://info.aldi.us/stores/l/ks/overland-park/8333-w-95th/f319",
      "poi_directions_map_url": "https://maps.google.com/?cid=8904277205991232046&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "aldi",
      "poi_latitude": "38.956629",
      "poi_longitude": "-94.682176",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 855-955-2534",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/019fc985-a5ca-725c-93ad-b1bb30597d45.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc985-a5ca-725c-93ad-b1bb30597d45",
        "storage_key": "property/6767906449167609/019fc985-a5ca-725c-93ad-b1bb30597d45.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_1c74KHrwIcRLhK3JPFYkns",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_74d6e129-8664-4099-876a-75ad1880cde1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "source": "custom",
      "poi_name": "Oak Park Mall",
      "poi_type": "Shopping & Retail",
      "poi_address": "11149 W 95th St, Overland Park, KS 66214, USA",
      "poi_short_description": "Busy, long-standing indoor shopping destination with 2 levels of popular brands & a food court.",
      "poi_long_description": "Busy, long-standing indoor shopping destination with 2 levels of popular brands & a food court.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/019fc985-7109-74b9-a38b-1ae55235c661.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc985-7109-74b9-a38b-1ae55235c661",
        "storage_key": "property/6767906449167609/019fc985-7109-74b9-a38b-1ae55235c661.webp",
        "width": 851,
        "height": 315
      },
      "poi_business_url": "https://www.shopoakparkmall.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3751688215534709327&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "oak-park-mall",
      "poi_latitude": "38.9530939",
      "poi_longitude": "-94.7196254",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 913-888-4400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/019fc985-a5bd-70f7-86c1-c78e95bf32af.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc985-a5bd-70f7-86c1-c78e95bf32af",
        "storage_key": "property/6767906449167609/019fc985-a5bd-70f7-86c1-c78e95bf32af.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJzVbG9zXrwIcRTyr3Ao6sEDQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_e35e7ed0-8787-445c-8dd1-bb39cd2d7c8b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "source": "custom",
      "poi_name": "Target",
      "poi_type": "Shopping & Retail",
      "poi_address": "11501 W 97th St, Overland Park, KS 66214, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/019fc98a-2b76-70cd-bda3-4e12d174f27a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc98a-2b76-70cd-bda3-4e12d174f27a",
        "storage_key": "property/6767906449167609/019fc98a-2b76-70cd-bda3-4e12d174f27a.webp",
        "width": 1280,
        "height": 699
      },
      "poi_business_url": "https://www.target.com/sl/overland-park-west/2043",
      "poi_directions_map_url": "https://maps.google.com/?cid=11588226477518387963&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "target",
      "poi_latitude": "38.95072090000001",
      "poi_longitude": "-94.7195414",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 913-905-0285",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/019fc985-a5bd-70f7-86c1-c78e95bf32af.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc985-a5bd-70f7-86c1-c78e95bf32af",
        "storage_key": "property/6767906449167609/019fc985-a5bd-70f7-86c1-c78e95bf32af.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ_Vxe5zbrwIcR-3pCkZWm0aA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_2f6a3c05-354f-4064-8309-2ed63de0c796",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "source": "custom",
      "poi_name": "Casey's",
      "poi_type": "Restaurants",
      "poi_address": "7475 W 95th St, Overland Park, KS 66212, USA",
      "poi_short_description": "Gas station offering fuels and snacks, plus a car wash.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/019fc98a-18dc-718f-82a2-f20c097975cf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc98a-18dc-718f-82a2-f20c097975cf",
        "storage_key": "property/6767906449167609/019fc98a-18dc-718f-82a2-f20c097975cf.webp",
        "width": 1000,
        "height": 1000
      },
      "poi_business_url": "https://www.caseys.com/general-store/ks-overlandpark/7475-w-95th-street/4350?utm_medium=organic&utm_source=google&utm_campaign=DAC",
      "poi_directions_map_url": "https://maps.google.com/?cid=18354389564006818130&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "caseys",
      "poi_latitude": "38.9563676",
      "poi_longitude": "-94.6717996",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 913-430-6366",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/019fc985-a5cc-704b-a88b-3718738bba01.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc985-a5cc-704b-a88b-3718738bba01",
        "storage_key": "property/6767906449167609/019fc985-a5cc-704b-a88b-3718738bba01.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJUbiBI3nrwIcRUmHDDxDkt_4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_59cabe9d-20ba-4c67-9c47-ee485cd2a078",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "source": "custom",
      "poi_name": "Costco Wholesale",
      "poi_type": "Shopping & Retail",
      "poi_address": "12221 Blue Valley Pkwy, Overland Park, KS 66213, USA",
      "poi_short_description": "Members-only warehouse selling a huge variety of items including bulk groceries, electronics & more.",
      "poi_long_description": "Members-only warehouse selling a huge variety of items including bulk groceries, electronics & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/019ff6ad-cd07-75ad-878a-3b2c490d799a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6ad-cd07-75ad-878a-3b2c490d799a",
        "storage_key": "property/6767906449167609/019ff6ad-cd07-75ad-878a-3b2c490d799a.webp",
        "width": 1280,
        "height": 518
      },
      "poi_business_url": "https://www.costco.com/warehouse-locations/overland-park-KS-369.html?utm_term=KW&utm_campaign=Homepage&utm_medium=GMB&utm_source=Google&utm_content=Link",
      "poi_directions_map_url": "https://maps.google.com/?cid=12181420978670501186&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "costco-wholesale",
      "poi_latitude": "38.9065093",
      "poi_longitude": "-94.6707763",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 13 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 913-217-2050",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/019fc985-a5bd-70f7-86c1-c78e95bf32af.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc985-a5bd-70f7-86c1-c78e95bf32af",
        "storage_key": "property/6767906449167609/019fc985-a5bd-70f7-86c1-c78e95bf32af.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJg8cveG7qwIcRQn0lFdcZDak",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "warehouse_store"
    },
    {
      "id": "custom_03f90dc8-a9bf-4904-8f58-c15e68e732b3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "source": "custom",
      "poi_name": "Walgreens",
      "poi_type": "Health and Wellness",
      "poi_address": "9500 Antioch Rd, Overland Park, KS 66212, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/01a0b661-0d97-7569-8379-31ad2fd670fe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b661-0d97-7569-8379-31ad2fd670fe",
        "storage_key": "property/6767906449167609/01a0b661-0d97-7569-8379-31ad2fd670fe.webp",
        "width": 1280,
        "height": 900
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-9500+antioch+rd-overland+park-ks-66212/id=11370",
      "poi_directions_map_url": "https://maps.google.com/?cid=2757867379827177112&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "38.95620100000001",
      "poi_longitude": "-94.6869671",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 913-381-0138",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/019fc985-a5bc-7268-b17a-b260774c8ecb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc985-a5bc-7268-b17a-b260774c8ecb",
        "storage_key": "property/6767906449167609/019fc985-a5bc-7268-b17a-b260774c8ecb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1V7VyArrwIcRmHY8KMXpRSY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_735b4a5b-46b1-4637-b14a-2ca73587b223",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "source": "custom",
      "poi_name": "Apache Elementary School",
      "poi_type": "Education",
      "poi_address": "8910 Goddard St, Overland Park, KS 66214, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/019fc98b-3aa7-759f-8e89-bdd5f84ef421.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc98b-3aa7-759f-8e89-bdd5f84ef421",
        "storage_key": "property/6767906449167609/019fc98b-3aa7-759f-8e89-bdd5f84ef421.webp",
        "width": 1280,
        "height": 669
      },
      "poi_business_url": "http://apache.smsd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13623856567814120774&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "apache-elementary-school",
      "poi_latitude": "38.9661075",
      "poi_longitude": "-94.711302",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 913-993-1600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/019fc985-a5cc-704b-a88b-33e77fb60140.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc985-a5cc-704b-a88b-33e77fb60140",
        "storage_key": "property/6767906449167609/019fc985-a5cc-704b-a88b-33e77fb60140.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJs5KCyVzrwIcRRuVuu12pEb0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_504f968d-5c80-47a5-948f-913a564fa81b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "source": "custom",
      "poi_name": "Westridge Middle School",
      "poi_type": "Education",
      "poi_address": "9300 Nieman Rd, Overland Park, KS 66214, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/019fc98a-3491-763e-8e81-5f6491af3355.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc98a-3491-763e-8e81-5f6491af3355",
        "storage_key": "property/6767906449167609/019fc98a-3491-763e-8e81-5f6491af3355.webp",
        "width": 1280,
        "height": 640
      },
      "poi_business_url": "https://westridge.smsd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=217242892534723488&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "westridge-middle-school",
      "poi_latitude": "38.9590348",
      "poi_longitude": "-94.7157697",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 913-993-1200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/019fc985-a5cc-704b-a88b-33e77fb60140.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc985-a5cc-704b-a88b-33e77fb60140",
        "storage_key": "property/6767906449167609/019fc985-a5cc-704b-a88b-33e77fb60140.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJk5xqEUbrwIcRoLOCf0LNAwM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_54ada38f-4a17-4376-bae9-76c9c4490034",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "source": "custom",
      "poi_name": "Shawnee Mission West High School",
      "poi_type": "Education",
      "poi_address": "8800 W 85th St, Overland Park, KS 66212, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/019fc98a-3229-7038-806e-136c06368f8c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc98a-3229-7038-806e-136c06368f8c",
        "storage_key": "property/6767906449167609/019fc98a-3229-7038-806e-136c06368f8c.webp",
        "width": 1280,
        "height": 662
      },
      "poi_business_url": "http://smwest.smsd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1174450894079124931&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "shawnee-mission-west-high-school",
      "poi_latitude": "38.9764917",
      "poi_longitude": "-94.688317",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 913-993-7800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/019fc985-a5cc-704b-a88b-33e77fb60140.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc985-a5cc-704b-a88b-33e77fb60140",
        "storage_key": "property/6767906449167609/019fc985-a5cc-704b-a88b-33e77fb60140.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJG5Gk03_rwIcRw-W5m918TBA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_5a55a01d-0127-40c8-b9e1-8d2c8efcd0ee",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "source": "custom",
      "poi_name": "Oak Park-Carpenter Elementary School",
      "poi_type": "Education",
      "poi_address": "10000 Nieman Rd, Overland Park, KS 66214, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/01a0b661-1870-7098-99d4-429db3102746.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b661-1870-7098-99d4-429db3102746",
        "storage_key": "property/6767906449167609/01a0b661-1870-7098-99d4-429db3102746.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://oakparkcarpenter.smsd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15083199623749570531&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "oak-park-carpenter-elementary-school",
      "poi_latitude": "38.9458089",
      "poi_longitude": "-94.7145831",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 913-993-4100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/019fc985-a5cc-704b-a88b-33e77fb60140.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc985-a5cc-704b-a88b-33e77fb60140",
        "storage_key": "property/6767906449167609/019fc985-a5cc-704b-a88b-33e77fb60140.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ5zGHHzvrwIcR4w_mwSRKUtE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_509555f3-a404-4598-813a-1ecf9d83f819",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "source": "custom",
      "poi_name": "Overland Park Elementary School",
      "poi_type": "Education",
      "poi_address": "8150 Santa Fe Dr, Overland Park, KS 66204, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/019fc98b-6995-767a-a7fb-3112cbf130bf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc98b-6995-767a-a7fb-3112cbf130bf",
        "storage_key": "property/6767906449167609/019fc98b-6995-767a-a7fb-3112cbf130bf.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://overlandpark.smsd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17740544643128892125&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "overland-park-elementary-school",
      "poi_latitude": "38.9816557",
      "poi_longitude": "-94.6764526",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 913-993-4200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/019fc985-a5cc-704b-a88b-33e77fb60140.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc985-a5cc-704b-a88b-33e77fb60140",
        "storage_key": "property/6767906449167609/019fc985-a5cc-704b-a88b-33e77fb60140.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ1S6G23nswIcR3RqoB1wTM_Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_3869366a-d04d-4b08-9503-1fd96424a6e3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "source": "custom",
      "poi_name": "Mt. Olive Lutheran Church",
      "poi_type": "Education",
      "poi_address": "9514 Perry Ln, Overland Park, KS 66212, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/01a0b661-1949-728d-8a84-19c147a2d9be.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b661-1949-728d-8a84-19c147a2d9be",
        "storage_key": "property/6767906449167609/01a0b661-1949-728d-8a84-19c147a2d9be.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://mtolivewels.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8031092849036613010&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mt-olive-lutheran-church",
      "poi_latitude": "38.9561075",
      "poi_longitude": "-94.704217",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 913-492-9740",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/01a0b661-3c51-756d-ad58-97df43efefed.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0b661-3c51-756d-ad58-97df43efefed",
        "storage_key": "property/6767906449167609/01a0b661-3c51-756d-ad58-97df43efefed.webp",
        "width": 144,
        "height": 192
      },
      "poi_google_place_id": "ChIJO67_KWvrwIcRktUBSWUsdG8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "church"
    },
    {
      "id": "custom_00b23ebe-a58c-41b8-8178-b496d26a5037",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "source": "custom",
      "poi_name": "Overland Christian School",
      "poi_type": "Education",
      "poi_address": "7016 W 74th St, Overland Park, KS 66204, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://overlandchristian.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15224425969390430137&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "overland-christian-school",
      "poi_latitude": "38.9955097",
      "poi_longitude": "-94.6659802",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 913-948-9994",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/019fc985-a5cc-704b-a88b-33e77fb60140.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc985-a5cc-704b-a88b-33e77fb60140",
        "storage_key": "property/6767906449167609/019fc985-a5cc-704b-a88b-33e77fb60140.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJG6YXNGvswIcRuae_tsEGSNM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_c6771b5c-3f7d-477a-ad80-2451af19cc55",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "source": "custom",
      "poi_name": "Children’s Village Montessori School",
      "poi_type": "Education",
      "poi_address": "10026 W 88th St, Overland Park, KS 66212, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://cvmsop.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6271027599509414304&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "childrens-village-montessori-school",
      "poi_latitude": "38.9700287",
      "poi_longitude": "-94.7023309",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 913-888-0434",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/019fc985-a5cc-704b-a88b-33e77fb60140.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc985-a5cc-704b-a88b-33e77fb60140",
        "storage_key": "property/6767906449167609/019fc985-a5cc-704b-a88b-33e77fb60140.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJhX2ogmbrwIcRoOFtXWAqB1c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "custom_0069f923-8510-4ac5-ae58-9299e53ba264",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "source": "custom",
      "poi_name": "Johnson County Community College",
      "poi_type": "Education",
      "poi_address": "12345 College Blvd, Overland Park, KS 66210, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/019fc985-727e-77eb-a901-9ae79da6bd52.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc985-727e-77eb-a901-9ae79da6bd52",
        "storage_key": "property/6767906449167609/019fc985-727e-77eb-a901-9ae79da6bd52.webp",
        "width": 960,
        "height": 540
      },
      "poi_business_url": "https://www.jccc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4939079639992649295&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "johnson-county-community-college",
      "poi_latitude": "38.9237619",
      "poi_longitude": "-94.7303185",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 57 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 913-469-8500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/019fc985-a5cc-704b-a88b-33e77fb60140.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc985-a5cc-704b-a88b-33e77fb60140",
        "storage_key": "property/6767906449167609/019fc985-a5cc-704b-a88b-33e77fb60140.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJEejhg2TrwIcRT0Ygo8Mii0Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_b265facb-ffe9-4777-a63e-a0a9ed041927",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "source": "custom",
      "poi_name": "University of Kansas Edwards Campus",
      "poi_type": "Education",
      "poi_address": "12600 S Quivira Rd, Overland Park, KS 66213, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/019ff6ad-eb73-77a9-b7d1-417c458856fe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6ad-eb73-77a9-b7d1-417c458856fe",
        "storage_key": "property/6767906449167609/019ff6ad-eb73-77a9-b7d1-417c458856fe.webp",
        "width": 1280,
        "height": 795
      },
      "poi_business_url": "http://edwardscampus.ku.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15421529977661014929&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "university-of-kansas-edwards-campus",
      "poi_latitude": "38.900081",
      "poi_longitude": "-94.7254776",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 27 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 913-897-8400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/019fc985-a5cc-704b-a88b-33e77fb60140.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc985-a5cc-704b-a88b-33e77fb60140",
        "storage_key": "property/6767906449167609/019fc985-a5cc-704b-a88b-33e77fb60140.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJcfRKua3qwIcRkcOF085HBNY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_b4c51325-3403-4b47-b830-ed97a239f7aa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "source": "custom",
      "poi_name": "Deanna Rose Children's Farmstead",
      "poi_type": "Entertainment",
      "poi_address": "13800 Switzer Rd, Overland Park, KS 66221, USA",
      "poi_short_description": "Spacious farmstead featuring replicas of life on the prairie, an ice cream parlor & wagon rides.",
      "poi_long_description": "Spacious farmstead featuring replicas of life on the prairie, an ice cream parlor & wagon rides.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/019fc98a-62b3-757d-a856-4a2d59c9bd69.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc98a-62b3-757d-a856-4a2d59c9bd69",
        "storage_key": "property/6767906449167609/019fc98a-62b3-757d-a856-4a2d59c9bd69.webp",
        "width": 640,
        "height": 349
      },
      "poi_business_url": "http://www.opkansas.org/things-to-see-and-do/deanna-rose-childrens-farmstead/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7835830010939554497&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "deanna-rose-childrens-farmstead",
      "poi_latitude": "38.877729",
      "poi_longitude": "-94.703345",
      "poi_miles_from_property": "8.3",
      "poi_walking_minutes": "3 hours 4 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 913-897-2360",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/019fc985-a5bc-7268-b17a-b260774c8ecb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc985-a5bc-7268-b17a-b260774c8ecb",
        "storage_key": "property/6767906449167609/019fc985-a5bc-7268-b17a-b260774c8ecb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJt6IUwjvAwIcRwbplAuF1vmw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_503b83aa-42ae-4a5f-8f04-4b2bb4f5e365",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "source": "custom",
      "poi_name": "Museum at Prairiefire",
      "poi_type": "Entertainment",
      "poi_address": "5801 W 135th St, Overland Park, KS 66223, USA",
      "poi_short_description": "Bright, uniquely designed museum with changing natural history exhibits on dinosaurs & space.",
      "poi_long_description": "Bright, uniquely designed museum with changing natural history exhibits on dinosaurs & space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/019fc98a-786f-767d-a722-2ed08ee8d2b2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc98a-786f-767d-a722-2ed08ee8d2b2",
        "storage_key": "property/6767906449167609/019fc98a-786f-767d-a722-2ed08ee8d2b2.webp",
        "width": 1170,
        "height": 797
      },
      "poi_business_url": "https://www.visitthemap.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9011883457387750483&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "museum-at-prairiefire",
      "poi_latitude": "38.8819446",
      "poi_longitude": "-94.6520905",
      "poi_miles_from_property": "8.7",
      "poi_walking_minutes": "3 hours 14 mins",
      "poi_biking_minutes": "53 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 913-333-3500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/019fc985-a5bc-7268-b17a-ae543563cd25.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc985-a5bc-7268-b17a-ae543563cd25",
        "storage_key": "property/6767906449167609/019fc985-a5bc-7268-b17a-ae543563cd25.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJOdDvHPHBwIcRU-TQ6kGkEH0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_cacf7da7-f9b4-4410-90f9-0c35191d6a17",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "source": "custom",
      "poi_name": "Nerman Museum of Contemporary Art",
      "poi_type": "Entertainment",
      "poi_address": "12345 College Blvd, Overland Park, KS 66210, USA",
      "poi_short_description": "Johnson County Community College's modern-art facility including an auditorium, cafe & classrooms.",
      "poi_long_description": "Johnson County Community College's modern-art facility including an auditorium, cafe & classrooms.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/019fc985-79fb-71ff-8075-2113b1889538.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc985-79fb-71ff-8075-2113b1889538",
        "storage_key": "property/6767906449167609/019fc985-79fb-71ff-8075-2113b1889538.webp",
        "width": 1080,
        "height": 830
      },
      "poi_business_url": "http://www.nermanmuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4973184191241098516&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nerman-museum-of-contemporary-art",
      "poi_latitude": "38.924852",
      "poi_longitude": "-94.726824",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 52 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 913-469-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/019fc985-a5bc-7268-b17a-ae543563cd25.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc985-a5bc-7268-b17a-ae543563cd25",
        "storage_key": "property/6767906449167609/019fc985-a5bc-7268-b17a-ae543563cd25.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJgVtOx9LqwIcRFJWDQaxMBEU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "art_museum"
    },
    {
      "id": "custom_793e0e89-5f69-4625-8f1b-bc4d16d1e488",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "source": "custom",
      "poi_name": "Overland Park Arboretum & Botanical Gardens",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "8909 W 179th St, Overland Park, KS 66013, USA",
      "poi_short_description": "Gardens, trails & recreation areas plus educational programs & events on environmental issues.",
      "poi_long_description": "Gardens, trails & recreation areas plus educational programs & events on environmental issues.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/019fc98a-a637-743c-830d-c2a7dc765279.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc98a-a637-743c-830d-c2a7dc765279",
        "storage_key": "property/6767906449167609/019fc98a-a637-743c-830d-c2a7dc765279.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.opkansas.org/recreation-fun/arboretum-botanical-gardens/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8713039177416778041&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "overland-park-arboretum--botanical-gardens",
      "poi_latitude": "38.8033925",
      "poi_longitude": "-94.6891159",
      "poi_miles_from_property": "14",
      "poi_walking_minutes": "5 hours 11 mins",
      "poi_biking_minutes": "1 hour 23 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 913-685-3604",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/019fc985-a5bc-7268-b17a-b260774c8ecb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc985-a5bc-7268-b17a-b260774c8ecb",
        "storage_key": "property/6767906449167609/019fc985-a5bc-7268-b17a-b260774c8ecb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6csjvynHwIcROSH92_fu6ng",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "botanical_garden"
    },
    {
      "id": "custom_dad90b96-35e8-4a83-b250-3f0a5b6bb40b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "source": "custom",
      "poi_name": "AMC Prairiefire 17",
      "poi_type": "Entertainment",
      "poi_address": "5724 W 136th St, Overland Park, KS 66223, USA",
      "poi_short_description": "Comfortable entertainment venue featuring a full menu alongside movie screenings of new releases.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/019ff6ad-d079-73e9-9aff-5744a823c30c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6ad-d079-73e9-9aff-5744a823c30c",
        "storage_key": "property/6767906449167609/019ff6ad-d079-73e9-9aff-5744a823c30c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.amctheatres.com/movie-theatres/kansas-city/amc-prairiefire-17?utm_medium=organic&utm_source=google&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=3727223515720771879&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "amc-prairiefire-17",
      "poi_latitude": "38.8826984",
      "poi_longitude": "-94.651566",
      "poi_miles_from_property": "8.6",
      "poi_walking_minutes": "3 hours 12 mins",
      "poi_biking_minutes": "53 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 913-553-3075",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/019fc98b-c815-7162-ad1a-8bbbc5060288.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98b-c815-7162-ad1a-8bbbc5060288",
        "storage_key": "property/6767906449167609/019fc98b-c815-7162-ad1a-8bbbc5060288.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7fXu5_DBwIcRJ-kENQrCuTM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_6c7bfb65-26ac-4207-8878-d4e8d251f069",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "source": "custom",
      "poi_name": "AMC Town Center 20",
      "poi_type": "Entertainment",
      "poi_address": "11701 Nall Ave, Leawood, KS 66211, USA",
      "poi_short_description": "Modern cinema equipped with comfy seats, luxury recliners, and a snack bar.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/01a01010-ddf0-74f6-a47d-d9d1f11e8bac.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01010-ddf0-74f6-a47d-d9d1f11e8bac",
        "storage_key": "property/6767906449167609/01a01010-ddf0-74f6-a47d-d9d1f11e8bac.webp",
        "width": 1280,
        "height": 783
      },
      "poi_business_url": "https://www.amctheatres.com/movie-theatres/kansas-city/amc-town-center-20?utm_medium=organic&utm_source=google&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=2804340900304979407&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "amc-town-center-20",
      "poi_latitude": "38.915838",
      "poi_longitude": "-94.648325",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 26 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 913-498-8696",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/019fc98b-c815-7162-ad1a-8bbbc5060288.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98b-c815-7162-ad1a-8bbbc5060288",
        "storage_key": "property/6767906449167609/019fc98b-c815-7162-ad1a-8bbbc5060288.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6xgReh_qwIcRzwXH1zAF6yY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_60e297e6-3c62-40ac-92e6-fe65aec18b6c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "source": "custom",
      "poi_name": "B&B Theatres Overland Park 16",
      "poi_type": "Entertainment",
      "poi_address": "8601 W 135th St, Overland Park, KS 66223, USA",
      "poi_short_description": "Relaxed, contemporary multiscreen theater featuring showings of mainstream films.",
      "poi_long_description": "Relaxed, contemporary multiscreen theater featuring showings of mainstream films.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/019fc98a-97cb-703d-9a1c-03484104f429.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc98a-97cb-703d-9a1c-03484104f429",
        "storage_key": "property/6767906449167609/019fc98a-97cb-703d-9a1c-03484104f429.webp",
        "width": 1280,
        "height": 950
      },
      "poi_business_url": "https://www.bbtheatres.com/our-theatres/x0uvh-b-and-b-overland-park-16/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6259761698616561138&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bb-theatres-overland-park-16",
      "poi_latitude": "38.8812512",
      "poi_longitude": "-94.6835183",
      "poi_miles_from_property": "7.3",
      "poi_walking_minutes": "2 hours 41 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 913-871-5352",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/019fc98b-c815-7162-ad1a-8bbbc5060288.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98b-c815-7162-ad1a-8bbbc5060288",
        "storage_key": "property/6767906449167609/019fc98b-c815-7162-ad1a-8bbbc5060288.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJDWO_qc3BwIcR8s2iaBkk31Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_58be74f9-0f0f-4eaf-be0c-ff5a3c93b781",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "source": "custom",
      "poi_name": "Glenwood Arts Theater",
      "poi_type": "Entertainment",
      "poi_address": "3707 W 95th St, Overland Park, KS 66206, USA",
      "poi_short_description": "Comfortable, retro cinema showing indie and art house fare, plus a film festival.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/019fc98b-752f-7298-8366-1d29493f699d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc98b-752f-7298-8366-1d29493f699d",
        "storage_key": "property/6767906449167609/019fc98b-752f-7298-8366-1d29493f699d.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.fineartsgroup.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17636666982984736873&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "glenwood-arts-theater",
      "poi_latitude": "38.9560792",
      "poi_longitude": "-94.629011",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 49 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 913-642-1132",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/019fc98b-c815-7162-ad1a-8bbbc5060288.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98b-c815-7162-ad1a-8bbbc5060288",
        "storage_key": "property/6767906449167609/019fc98b-c815-7162-ad1a-8bbbc5060288.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJl1p4ub_rwIcRaWCqji0HwvQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_ebd92535-8a93-4f2e-a4c5-4f7c5a3461f4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "source": "custom",
      "poi_name": "Chicken N Pickle - Overland Park",
      "poi_type": "Restaurants",
      "poi_address": "5901 W 135th St, Overland Park, KS 66223, USA",
      "poi_short_description": "Family-friendly venue with pickleball courts and other games, plus a casual restaurant.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/019fc98a-b113-7739-b08c-488a8ad7ef98.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc98a-b113-7739-b08c-488a8ad7ef98",
        "storage_key": "property/6767906449167609/019fc98a-b113-7739-b08c-488a8ad7ef98.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://chickennpickle.com/location/overland-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3904135511973972812&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chicken-n-pickle---overland-park",
      "poi_latitude": "38.8830518",
      "poi_longitude": "-94.6552102",
      "poi_miles_from_property": "8.5",
      "poi_walking_minutes": "3 hours 9 mins",
      "poi_biking_minutes": "54 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 913-703-5950",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/019fc985-a5cc-704b-a88b-3718738bba01.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc985-a5cc-704b-a88b-3718738bba01",
        "storage_key": "property/6767906449167609/019fc985-a5cc-704b-a88b-3718738bba01.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ9D8rijBwIcRTEsyKpBGLjY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_79049fc2-5915-440d-99d9-cc8a1715ba74",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "source": "custom",
      "poi_name": "Dave & Buster's Overland Park",
      "poi_type": "Restaurants",
      "poi_address": "6811 W 135th St, Overland Park, KS 66223, USA",
      "poi_short_description": "Family-friendly chain offering a sports-bar-style setting for American food & arcade games.",
      "poi_long_description": "Family-friendly chain offering a sports-bar-style setting for American food & arcade games.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/01a0b661-1c74-719e-9eff-3fdc23564c4c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b661-1c74-719e-9eff-3fdc23564c4c",
        "storage_key": "property/6767906449167609/01a0b661-1c74-719e-9eff-3fdc23564c4c.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.daveandbusters.com/us/en/about/locations/overland-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=2445764442989428663&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dave--busters-overland-park",
      "poi_latitude": "38.88149050000001",
      "poi_longitude": "-94.6652889",
      "poi_miles_from_property": "8",
      "poi_walking_minutes": "2 hours 58 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 913-249-3900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/019fc985-a5cc-704b-a88b-3718738bba01.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc985-a5cc-704b-a88b-3718738bba01",
        "storage_key": "property/6767906449167609/019fc985-a5cc-704b-a88b-3718738bba01.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJgVr1MujBwIcRt3-qfM0Z8SE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_b4ca7f7a-ea45-4871-8199-c21ed1200a39",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "source": "custom",
      "poi_name": "Saint Luke's South Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "12300 Metcalf Ave, Overland Park, KS 66213, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/019fc98b-40d1-7249-868a-d7c34965720d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc98b-40d1-7249-868a-d7c34965720d",
        "storage_key": "property/6767906449167609/019fc98b-40d1-7249-868a-d7c34965720d.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.saintlukeskc.org/locations/saint-lukes-south-hospital?utm_source=local-listing&utm_medium=organic&utm_campaign=website-link",
      "poi_directions_map_url": "https://maps.google.com/?cid=8966224544508452770&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "saint-lukes-south-hospital",
      "poi_latitude": "38.9041982",
      "poi_longitude": "-94.6695167",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 23 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 913-317-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/019fc985-a5bc-7268-b17a-b600f65b9d3c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc985-a5bc-7268-b17a-b600f65b9d3c",
        "storage_key": "property/6767906449167609/019fc985-a5bc-7268-b17a-b600f65b9d3c.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJkT2aF3LqwIcRop_Q17dtbnw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "custom_5f039cca-8eb1-47df-84cc-3b20f35e966c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "source": "custom",
      "poi_name": "Overland Park Regional Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "10500 Quivira Rd, Overland Park, KS 66215, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/019fc98a-9495-7687-a6b2-210b91da2aa5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc98a-9495-7687-a6b2-210b91da2aa5",
        "storage_key": "property/6767906449167609/019fc98a-9495-7687-a6b2-210b91da2aa5.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "https://www.hcamidwest.com/locations/overland-park-regional-medical-center?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=13555409796355494155&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "overland-park-regional-medical-center",
      "poi_latitude": "38.9376197",
      "poi_longitude": "-94.7261812",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 913-541-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/019fc985-a5bc-7268-b17a-b600f65b9d3c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc985-a5bc-7268-b17a-b600f65b9d3c",
        "storage_key": "property/6767906449167609/019fc985-a5bc-7268-b17a-b600f65b9d3c.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4cFCWJzAwIcRC5Ge4GN9Hrw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_3579021d-9b8d-4455-8b88-ded8623ba470",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "source": "custom",
      "poi_name": "Saint Luke's Convenient Care - Hy-Vee 95th & Antioch",
      "poi_type": "Health and Wellness",
      "poi_address": "8501 W 95th St, Overland Park, KS 66212, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/019ff6ad-db0a-709a-9ea0-e25fe23e43dc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6ad-db0a-709a-9ea0-e25fe23e43dc",
        "storage_key": "property/6767906449167609/019ff6ad-db0a-709a-9ea0-e25fe23e43dc.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.saintlukeskc.org/samedaycare?utm_source=local-listing&utm_medium=organic&utm_campaign=website-link",
      "poi_directions_map_url": "https://maps.google.com/?cid=7005954362786686182&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "saint-lukes-convenient-care---hy-vee-95th--antioch",
      "poi_latitude": "38.9558212",
      "poi_longitude": "-94.6844396",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 913-323-8880",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/019fc985-a5bc-7268-b17a-b260774c8ecb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc985-a5bc-7268-b17a-b260774c8ecb",
        "storage_key": "property/6767906449167609/019fc985-a5bc-7268-b17a-b260774c8ecb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJhcJNLaDrwIcR5qR_sl8mOmE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_0f3209ca-e76a-48cb-acb5-c71d3ae8e106",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "source": "custom",
      "poi_name": "CareNow Urgent Care - Overland Park North",
      "poi_type": "Health and Wellness",
      "poi_address": "9507 Antioch Rd, Overland Park, KS 66212, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/019ff6ad-d649-705f-bf65-bb021f60282c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6ad-d649-705f-bf65-bb021f60282c",
        "storage_key": "property/6767906449167609/019ff6ad-d649-705f-bf65-bb021f60282c.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.carenow.com/locations/kansas-city/overland-park-north?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=17796506606246617401&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "carenow-urgent-care---overland-park-north",
      "poi_latitude": "38.9558927",
      "poi_longitude": "-94.6859458",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 913-227-4631",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/019fc985-a5bc-7268-b17a-b260774c8ecb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc985-a5bc-7268-b17a-b260774c8ecb",
        "storage_key": "property/6767906449167609/019fc985-a5bc-7268-b17a-b260774c8ecb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJkZTQ_5_rwIcROeE47Hfk-fY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_48608d6e-bc2c-487e-b789-bf1e90ee405b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "source": "custom",
      "poi_name": "Hy-Vee Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "8501 W 95th St, Overland Park, KS 66212, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/01a01010-df2d-7798-b507-544b4d1e1ad5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01010-df2d-7798-b507-544b4d1e1ad5",
        "storage_key": "property/6767906449167609/01a01010-df2d-7798-b507-544b4d1e1ad5.webp",
        "width": 1280,
        "height": 771
      },
      "poi_business_url": "https://www.hy-vee.com/my-pharmacy/pharmacy-finder/overland-park-1-8501-w-95th-st-overland-park-ks/1508?utm_source=google&utm_medium=organic&utm_campaign=gmb-listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=1246817757684703566&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hy-vee-pharmacy",
      "poi_latitude": "38.9555875",
      "poi_longitude": "-94.6837171",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 913-894-2079",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/019fc98b-c814-7312-ad90-ce1a2e842eda.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98b-c814-7312-ad90-ce1a2e842eda",
        "storage_key": "property/6767906449167609/019fc98b-c814-7312-ad90-ce1a2e842eda.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJx63xiJ_rwIcRTiFyCiWWTRE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_00b71e58-d4bb-44df-bbef-1172aa4caa1a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "source": "custom",
      "poi_name": "CVS",
      "poi_type": "Health and Wellness",
      "poi_address": "8800 W 95th St, Overland Park, KS 66212, USA",
      "poi_short_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_long_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/01a0b661-1f7f-72cc-8f71-78592a4bfc2d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b661-1f7f-72cc-8f71-78592a4bfc2d",
        "storage_key": "property/6767906449167609/01a0b661-1f7f-72cc-8f71-78592a4bfc2d.webp",
        "width": 1280,
        "height": 691
      },
      "poi_business_url": "https://www.cvs.com/store-locator/overland-park-ks-pharmacies/8800-w-95th-street-overland-park-ks-66212/storeid=8582?WT.mc_id=LS_GOOGLE_FS_8582",
      "poi_directions_map_url": "https://maps.google.com/?cid=16254116886537596105&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs",
      "poi_latitude": "38.95741659999999",
      "poi_longitude": "-94.6872668",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 913-381-8184",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/019fc985-a5bc-7268-b17a-b260774c8ecb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc985-a5bc-7268-b17a-b260774c8ecb",
        "storage_key": "property/6767906449167609/019fc985-a5bc-7268-b17a-b260774c8ecb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJRyRYR3XrwIcRyWzAtzA5kuE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_8e9358eb-1d57-4387-8516-fb0907bf7587",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "9331 Quivira Rd, Overland Park, KS 66215, USA",
      "poi_short_description": "Friendly chain gym offering treadmills and other equipment, plus classes.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/019fc985-834d-773f-a34f-3d21e1765d7e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc985-834d-773f-a34f-3d21e1765d7e",
        "storage_key": "property/6767906449167609/019fc985-834d-773f-a34f-3d21e1765d7e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/overland-park-93rd-quivira-ks?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=9830202165263287199&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "38.9596389",
      "poi_longitude": "-94.7231493",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 913-717-6070",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/019fc985-a5bc-7268-b17a-b260774c8ecb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc985-a5bc-7268-b17a-b260774c8ecb",
        "storage_key": "property/6767906449167609/019fc985-a5bc-7268-b17a-b260774c8ecb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJA3RFIs6UwIcRn0PLYsnka4g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_20befab7-4596-4c46-9fd9-376945d109e7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "source": "custom",
      "poi_name": "Anytime Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "8809 W 95th St, Overland Park, KS 66212, USA",
      "poi_short_description": "Chain fitness center offering 24-hour access, plus personal training and group workouts.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/019ff6ad-e0ed-772f-9a6a-94cd30e56302.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6ad-e0ed-772f-9a6a-94cd30e56302",
        "storage_key": "property/6767906449167609/019ff6ad-e0ed-772f-9a6a-94cd30e56302.webp",
        "width": 1280,
        "height": 852
      },
      "poi_business_url": "https://www.anytimefitness.com/locations/overland-park-kansas-5338/?utm_source=google&utm_medium=organic-businesslisting&utm_campaign=gbp-listing&utm_content=255",
      "poi_directions_map_url": "https://maps.google.com/?cid=14420210980381975777&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "anytime-fitness",
      "poi_latitude": "38.9558612",
      "poi_longitude": "-94.6885189",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 913-871-7461",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/019fc985-a5bc-7268-b17a-b260774c8ecb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc985-a5bc-7268-b17a-b260774c8ecb",
        "storage_key": "property/6767906449167609/019fc985-a5bc-7268-b17a-b260774c8ecb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJUyETlL3rwIcR4eTaL3zhHsg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_70a71852-30a7-4e45-a704-cbeb5fa37184",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "source": "custom",
      "poi_name": "Goddess Maker Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "7275 W 105th St, Overland Park, KS 66212, USA",
      "poi_short_description": "Gym specializing in strength and fitness training for women.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/01a0b661-1fdb-70ca-9f90-e61b81e9c8aa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b661-1fdb-70ca-9f90-e61b81e9c8aa",
        "storage_key": "property/6767906449167609/01a0b661-1fdb-70ca-9f90-e61b81e9c8aa.webp",
        "width": 851,
        "height": 315
      },
      "poi_business_url": "http://www.goddessmakerfitness.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6107595536998620061&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "goddess-maker-fitness",
      "poi_latitude": "38.937454",
      "poi_longitude": "-94.6700347",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 913-481-0641",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/019fc985-a5bc-7268-b17a-b260774c8ecb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc985-a5bc-7268-b17a-b260774c8ecb",
        "storage_key": "property/6767906449167609/019fc985-a5bc-7268-b17a-b260774c8ecb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJF4OXeU3rwIcRnVuQDsiJwlQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_1c3f510e-3d23-45c0-9eae-3cbf538b70e0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "source": "custom",
      "poi_name": "James Place Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "6301 Indian Creek Dr, Overland Park, KS 66212, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/01a0b661-22b2-7718-938b-137722b4602b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b661-22b2-7718-938b-137722b4602b",
        "storage_key": "property/6767906449167609/01a0b661-22b2-7718-938b-137722b4602b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://opkansas.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7199580260294972862&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "james-place-park",
      "poi_latitude": "38.93971690000001",
      "poi_longitude": "-94.6610932",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 36 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 913-895-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/019fc985-a5cb-73ad-8866-ccbf968324c3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc985-a5cb-73ad-8866-ccbf968324c3",
        "storage_key": "property/6767906449167609/019fc985-a5cb-73ad-8866-ccbf968324c3.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJX0y72MvrwIcRvtXLChoM6mM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_195e7368-76d5-4fca-9da2-c7157965407b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "source": "custom",
      "poi_name": "Nall Hills Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5501 Indian Creek Dr, Overland Park, KS 66207, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/019ff6d7-e7f0-729a-9c86-87684a752256.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6d7-e7f0-729a-9c86-87684a752256",
        "storage_key": "property/6767906449167609/019ff6d7-e7f0-729a-9c86-87684a752256.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.opkansas.org/park/nall-hills-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15640790860681485836&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nall-hills-park",
      "poi_latitude": "38.938963",
      "poi_longitude": "-94.651414",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 47 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 913-895-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/019fc985-a5cb-73ad-8866-ccbf968324c3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc985-a5cb-73ad-8866-ccbf968324c3",
        "storage_key": "property/6767906449167609/019fc985-a5cb-73ad-8866-ccbf968324c3.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_3cm1f7rwIcRDJ4YWWtAD9k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_ac566a2f-2201-4513-b9ff-96aad7b19d45",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "source": "custom",
      "poi_name": "Pinehurst East Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "10210 Glenwood St, Overland Park, KS 66212, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/01a0b661-2748-713b-af59-49885aefbd09.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b661-2748-713b-af59-49885aefbd09",
        "storage_key": "property/6767906449167609/01a0b661-2748-713b-af59-49885aefbd09.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://opkansas.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13927669142818851065&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pinehurst-east-park",
      "poi_latitude": "38.942582",
      "poi_longitude": "-94.662057",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 913-327-6630",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/019fc985-a5cb-73ad-8866-ccbf968324c3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc985-a5cb-73ad-8866-ccbf968324c3",
        "storage_key": "property/6767906449167609/019fc985-a5cb-73ad-8866-ccbf968324c3.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJkSIZacnrwIcR-QjjHksFScE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_71b82e5b-13ed-46f6-b73a-fe01e4400c10",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "source": "custom",
      "poi_name": "Indian Creek Recreation Center",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "10308 Marty St, Overland Park, KS 66212, USA",
      "poi_short_description": "Dog-friendly park with a playground and a small water park, plus tennis courts.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/019fc98a-f84a-7778-bf05-965add47fc8c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc98a-f84a-7778-bf05-965add47fc8c",
        "storage_key": "property/6767906449167609/019fc98a-f84a-7778-bf05-965add47fc8c.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.opkansas.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4418406476268149154&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "indian-creek-recreation-center",
      "poi_latitude": "38.9418777",
      "poi_longitude": "-94.6732051",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 913-895-6390",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/019fc985-a5cb-73ad-8866-ccbf968324c3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc985-a5cb-73ad-8866-ccbf968324c3",
        "storage_key": "property/6767906449167609/019fc985-a5cb-73ad-8866-ccbf968324c3.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4UBzebHrwIcRopk_y0dVUT0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_8f757b2b-8282-4da3-b28b-75757e1c632c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "source": "custom",
      "poi_name": "Cross Creek Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "10801 Indian Creek Pkwy, Overland Park, KS 66213, USA",
      "poi_short_description": "Recreation on 54+ acres, with preserve area, playground, picnic tables & trail for biking & hiking.",
      "poi_long_description": "Recreation on 54+ acres, with preserve area, playground, picnic tables & trail for biking & hiking.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/01a0b661-2a00-7228-830f-7f46480cc1c1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b661-2a00-7228-830f-7f46480cc1c1",
        "storage_key": "property/6767906449167609/01a0b661-2a00-7228-830f-7f46480cc1c1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.opkansas.org/things-to-see-and-do/parks/list-of-city-parks/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7674525964555940330&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cross-creek-park",
      "poi_latitude": "38.9179015",
      "poi_longitude": "-94.7094663",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 11 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 913-895-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/019fc985-a5cb-73ad-8866-ccbf968324c3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc985-a5cb-73ad-8866-ccbf968324c3",
        "storage_key": "property/6767906449167609/019fc985-a5cb-73ad-8866-ccbf968324c3.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJNRbH6JfqwIcR6nHeELRkgWo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_826f5a10-f034-4321-ac36-71d60109490c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "source": "custom",
      "poi_name": "Forest Creek Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "12501 Pflumm Rd, Overland Park, KS 66213, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/01a0b661-2f2c-72db-ba46-3a6589477916.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b661-2f2c-72db-ba46-3a6589477916",
        "storage_key": "property/6767906449167609/01a0b661-2f2c-72db-ba46-3a6589477916.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.opkansas.org/park/forest-creek-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15582652294195819573&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "forest-creek-park",
      "poi_latitude": "38.9012422",
      "poi_longitude": "-94.7372858",
      "poi_miles_from_property": "6.9",
      "poi_walking_minutes": "2 hours 33 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 913-895-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/019fc985-a5cb-73ad-8866-ccbf968324c3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc985-a5cb-73ad-8866-ccbf968324c3",
        "storage_key": "property/6767906449167609/019fc985-a5cb-73ad-8866-ccbf968324c3.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ25CyFlCVwIcRNbT3fbOzQNg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_84d5e6b5-8feb-4468-b173-7ad0ae34f67d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "source": "custom",
      "poi_name": "Brookridge Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "10100 Lowell Ave, Overland Park, KS 66212, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/01a01010-e2b4-76bc-8a89-ec5964f6c1fc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01010-e2b4-76bc-8a89-ec5964f6c1fc",
        "storage_key": "property/6767906449167609/01a01010-e2b4-76bc-8a89-ec5964f6c1fc.webp",
        "width": 348,
        "height": 348
      },
      "poi_business_url": "http://opkansas.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6433772751155709519&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "brookridge-park",
      "poi_latitude": "38.9460029",
      "poi_longitude": "-94.6776548",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 913-895-6390",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/019fc985-a5cb-73ad-8866-ccbf968324c3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc985-a5cb-73ad-8866-ccbf968324c3",
        "storage_key": "property/6767906449167609/019fc985-a5cb-73ad-8866-ccbf968324c3.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8dBzia_rwIcRT0Y5xjpaSVk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_2576e753-82d7-478f-b084-269f3bb9c0b2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "source": "custom",
      "poi_name": "Strang Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "West 88th and, Farley St, Overland Park, KS 66212, USA",
      "poi_short_description": "Relaxed playground-surrounded park featuring swings, basketball courts, and tennis courts along with a picnic shelter and a grill.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/019fc98b-0387-71c0-a2fa-9dbc1cb81f17.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc98b-0387-71c0-a2fa-9dbc1cb81f17",
        "storage_key": "property/6767906449167609/019fc98b-0387-71c0-a2fa-9dbc1cb81f17.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.opkansas.org/park/strang-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3266416833072127371&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "strang-park",
      "poi_latitude": "38.9679845",
      "poi_longitude": "-94.699823",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 913-895-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/019fc985-a5cb-73ad-8866-ccbf968324c3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc985-a5cb-73ad-8866-ccbf968324c3",
        "storage_key": "property/6767906449167609/019fc985-a5cb-73ad-8866-ccbf968324c3.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJUYsGCWXrwIcRi92er82kVC0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_d7712602-afaa-4485-9c62-21a3229a1b9a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "source": "custom",
      "poi_name": "Mission Transit Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "5251 Johnson Dr, Roeland Park, KS 66205, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://ridekc.org/locations/mission_transit_center",
      "poi_directions_map_url": "https://maps.google.com/?cid=14750820283784844061&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mission-transit-center",
      "poi_latitude": "39.0229186",
      "poi_longitude": "-94.6460432",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 2 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/019fc98b-ca65-70c8-90b8-95f6018f2a3c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98b-ca65-70c8-90b8-95f6018f2a3c",
        "storage_key": "property/6767906449167609/019fc98b-ca65-70c8-90b8-95f6018f2a3c.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0RGVf9XtwIcRHVOfGOVwtcw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "parking_lot"
    },
    {
      "id": "custom_1d739211-8670-483a-9813-c43eb2cf830b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "source": "custom",
      "poi_name": "Oak Park Mall Park and Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "Overland Park, KS 66214, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=13146997606835839132&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "oak-park-mall-park-and-ride",
      "poi_latitude": "38.954938",
      "poi_longitude": "-94.715914",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/019ff6ae-0b07-722f-96eb-e5e3129754f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6ae-0b07-722f-96eb-e5e3129754f6",
        "storage_key": "property/6767906449167609/019ff6ae-0b07-722f-96eb-e5e3129754f6.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJv9bmcDjrwIcRnGBc6qqEc7Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_station"
    },
    {
      "id": "custom_5210645e-e77c-463e-b7e8-b9edecd98969",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "source": "custom",
      "poi_name": "Midwest Trust Center",
      "poi_type": "Entertainment",
      "poi_address": "12345 College Blvd, Overland Park, KS 66210, USA",
      "poi_short_description": "Performing-arts center hosting a variety of concerts, dance performances & film screenings.",
      "poi_long_description": "Performing-arts center hosting a variety of concerts, dance performances & film screenings.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/019ff6ad-e52e-7275-a8d2-8ee444023066.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6ad-e52e-7275-a8d2-8ee444023066",
        "storage_key": "property/6767906449167609/019ff6ad-e52e-7275-a8d2-8ee444023066.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.jccc.edu/midwest-trust-center/",
      "poi_directions_map_url": "https://maps.google.com/?cid=333406106616415315&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "midwest-trust-center",
      "poi_latitude": "38.9252624",
      "poi_longitude": "-94.7279145",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 913-469-4445",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/019fc985-a5bc-7268-b17a-b260774c8ecb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc985-a5bc-7268-b17a-b260774c8ecb",
        "storage_key": "property/6767906449167609/019fc985-a5bc-7268-b17a-b260774c8ecb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJgVtOx9LqwIcRU0TRZhZ_oAQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_74ed45de-a2f4-4775-986d-1dca1644eef5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "source": "custom",
      "poi_name": "Heartland Community Church",
      "poi_type": "Transportation & Transit",
      "poi_address": "12175 S Strang Line Rd, Olathe, KS 66062, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/01a0b661-2c6a-74fd-94bd-e6d57490c85a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b661-2c6a-74fd-94bd-e6d57490c85a",
        "storage_key": "property/6767906449167609/01a0b661-2c6a-74fd-94bd-e6d57490c85a.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.heartlandchurch.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11439840584445010142&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "heartland-community-church",
      "poi_latitude": "38.9077079",
      "poi_longitude": "-94.7721404",
      "poi_miles_from_property": "7.7",
      "poi_walking_minutes": "2 hours 50 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 913-341-5820",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/01a0b661-3c51-756d-ad58-97df43efefed.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0b661-3c51-756d-ad58-97df43efefed",
        "storage_key": "property/6767906449167609/01a0b661-3c51-756d-ad58-97df43efefed.webp",
        "width": 144,
        "height": 192
      },
      "poi_google_place_id": "ChIJtZEk2J6VwIcR3iDxkmZ6wp4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "church"
    },
    {
      "id": "custom_1f4e0006-4816-460f-81c7-8a97d605f8f8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "source": "custom",
      "poi_name": "Kansas City",
      "poi_type": "Transportation & Transit",
      "poi_address": "30 W Pershing Rd Union Station, Kansas City, MO 64108, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/019ff6ad-fea2-734a-9b71-e58ebcd3eb20.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6ad-fea2-734a-9b71-e58ebcd3eb20",
        "storage_key": "property/6767906449167609/019ff6ad-fea2-734a-9b71-e58ebcd3eb20.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.amtrak.com/servlet/ContentServer?pagename=am/am2Station/Station_Page&code=KCY",
      "poi_directions_map_url": "https://maps.google.com/?cid=3787247529242741214&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kansas-city",
      "poi_latitude": "39.0847966",
      "poi_longitude": "-94.5853578",
      "poi_miles_from_property": "11.6",
      "poi_walking_minutes": "4 hours 17 mins",
      "poi_biking_minutes": "1 hour 12 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 800-872-7245",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/019ff6ae-0b01-73f5-8bf4-9d3a65f895a0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6ae-0b01-73f5-8bf4-9d3a65f895a0",
        "storage_key": "property/6767906449167609/019ff6ae-0b01-73f5-8bf4-9d3a65f895a0.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJxbu2nD_wwIcR3kn96I8BjzQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_cf8cdd20-2c05-48b0-905f-9c8f1d05f217",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "source": "custom",
      "poi_name": "Kansas City International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "1 Kansas City Blvd, Kansas City, MO 64153, USA",
      "poi_short_description": "Airport featuring domestic & global flights plus free WiFi & a variety of eateries.",
      "poi_long_description": "Airport featuring domestic & global flights plus free WiFi & a variety of eateries.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/019fc98b-2579-7588-8ea6-2f260e49d6ab.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc98b-2579-7588-8ea6-2f260e49d6ab",
        "storage_key": "property/6767906449167609/019fc98b-2579-7588-8ea6-2f260e49d6ab.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://www.flykc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14109162014977743520&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kansas-city-international-airport",
      "poi_latitude": "39.3013901",
      "poi_longitude": "-94.7104232",
      "poi_miles_from_property": "33.6",
      "poi_walking_minutes": "12 hours 29 mins",
      "poi_biking_minutes": "3 hours 45 mins",
      "poi_driving_minutes": "34 mins",
      "poi_business_phone": "+1 816-243-5237",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/019fc98b-ca50-760a-9fbe-ac7e7208032c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98b-ca50-760a-9fbe-ac7e7208032c",
        "storage_key": "property/6767906449167609/019fc98b-ca50-760a-9fbe-ac7e7208032c.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJmYfmiAhewIcRoNouXRnQzcM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "custom_e9958489-934c-49ad-8f43-c37719f93993",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "source": "custom",
      "poi_name": "Johnson County Library - Central Resource",
      "poi_type": "Education",
      "poi_address": "9875 W 87th St, Overland Park, KS 66212, USA",
      "poi_short_description": "Chain member featuring 3-D printers, comfy seating, study rooms, laser cutters, DVDs, videos and computers.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/019fc985-8031-77ad-bab5-e58c774c075c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc985-8031-77ad-bab5-e58c774c075c",
        "storage_key": "property/6767906449167609/019fc985-8031-77ad-bab5-e58c774c075c.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.jocolibrary.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1349495317663414986&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "johnson-county-library---central-resource",
      "poi_latitude": "38.9699019",
      "poi_longitude": "-94.6992076",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 913-826-4600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/019fc985-a5d9-744b-ad14-df3ab3e0afda.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc985-a5d9-744b-ad14-df3ab3e0afda",
        "storage_key": "property/6767906449167609/019fc985-a5d9-744b-ad14-df3ab3e0afda.webp",
        "width": 192,
        "height": 174
      },
      "poi_google_place_id": "ChIJ28bnX2TrwIcRynpha9deuhI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_7db857f7-6839-44cf-b79c-d9571d171e70",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "source": "custom",
      "poi_name": "On Antioch at w 83rd St Northbound",
      "poi_type": "Transportation & Transit",
      "poi_address": "Overland Park, KS 66212, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=14111891836971095157&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "on-antioch-at-w-83rd-st-northbound",
      "poi_latitude": "38.978413",
      "poi_longitude": "-94.68629",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/019fc98b-c9a2-7184-b1b4-72aa5bf140f5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98b-c9a2-7184-b1b4-72aa5bf140f5",
        "storage_key": "property/6767906449167609/019fc98b-c9a2-7184-b1b4-72aa5bf140f5.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7e1L4H_swIcRdZRlk9uC18M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "custom_362cb5b7-02b5-4898-9556-c7960601d35e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "source": "custom",
      "poi_name": "T-Mobile Corporate Office",
      "poi_type": "Major Employers & Offices",
      "poi_address": "6200 Sprint Pkwy, Overland Park, KS 66211, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=14760433863164848594&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "t-mobile-corporate-office",
      "poi_latitude": "38.9155509",
      "poi_longitude": "-94.6587944",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 25 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 855-977-5086",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/019fc985-a5bc-7268-b17a-b260774c8ecb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc985-a5bc-7268-b17a-b260774c8ecb",
        "storage_key": "property/6767906449167609/019fc985-a5bc-7268-b17a-b260774c8ecb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJCUnvFjzrwIcR0mmW-GSY18w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_2884acfe-98d3-4f6d-8455-b0a650d7ab0a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "source": "custom",
      "poi_name": "Black & Veatch",
      "poi_type": "Major Employers & Offices",
      "poi_address": "11401 Lamar Ave, Overland Park, KS 66211, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/019fc98b-57d9-73e8-a931-553178a91cfb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc98b-57d9-73e8-a931-553178a91cfb",
        "storage_key": "property/6767906449167609/019fc98b-57d9-73e8-a931-553178a91cfb.webp",
        "width": 1280,
        "height": 653
      },
      "poi_business_url": "http://www.bv.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15245877116558125981&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "black--veatch",
      "poi_latitude": "38.9250015",
      "poi_longitude": "-94.6553624",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 6 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 913-458-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/019fc985-a5bc-7268-b17a-b260774c8ecb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc985-a5bc-7268-b17a-b260774c8ecb",
        "storage_key": "property/6767906449167609/019fc985-a5bc-7268-b17a-b260774c8ecb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJUyTe2TrqwIcRnSu0HXY8lNM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "consultant"
    },
    {
      "id": "custom_b5c6bbf2-8ebf-4fd2-ab97-652da15e37b7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "source": "custom",
      "poi_name": "Garmin",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1200 E 151st St, Olathe, KS 66062, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/019ff6d7-eb58-773a-be48-a058542e232b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6d7-eb58-773a-be48-a058542e232b",
        "storage_key": "property/6767906449167609/019ff6d7-eb58-773a-be48-a058542e232b.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.garmin.com/en-US",
      "poi_directions_map_url": "https://maps.google.com/?cid=7856958804647333168&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "garmin",
      "poi_latitude": "38.8553721",
      "poi_longitude": "-94.7996464",
      "poi_miles_from_property": "12.1",
      "poi_walking_minutes": "4 hours 27 mins",
      "poi_biking_minutes": "1 hour 20 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 800-800-1020",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/019fc985-a5bc-7268-b17a-b260774c8ecb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc985-a5bc-7268-b17a-b260774c8ecb",
        "storage_key": "property/6767906449167609/019fc985-a5bc-7268-b17a-b260774c8ecb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJmdY73mS-wIcRMM3hpWeGCW0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_f388fded-87d3-4ab1-8aef-e4f5f2a9cbb2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "source": "custom",
      "poi_name": "Children's Mercy Kansas",
      "poi_type": "Health and Wellness",
      "poi_address": "5808 W 110th St, Overland Park, KS 66211, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/019fc985-8bf3-76ba-abbf-c400c0003413.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc985-8bf3-76ba-abbf-c400c0003413",
        "storage_key": "property/6767906449167609/019fc985-8bf3-76ba-abbf-c400c0003413.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://www.childrensmercy.org/Kansas/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8535209985424805612&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "childrens-mercy-kansas",
      "poi_latitude": "38.9299718",
      "poi_longitude": "-94.6522904",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 5 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 913-696-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/019fc985-a5bc-7268-b17a-b600f65b9d3c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc985-a5bc-7268-b17a-b600f65b9d3c",
        "storage_key": "property/6767906449167609/019fc985-a5bc-7268-b17a-b600f65b9d3c.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ03Xo8C7qwIcR7M6coEIoc3Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_640bc974-6e6b-4878-903c-c3b2a5309d4e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "source": "custom",
      "poi_name": "OptumRx Fulfillment",
      "poi_type": "Health and Wellness",
      "poi_address": "6800 W 115th St suite 600, Overland Park, KS 66211, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/019fc98b-3efd-75dd-a53c-40679aa4e74b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc98b-3efd-75dd-a53c-40679aa4e74b",
        "storage_key": "property/6767906449167609/019fc98b-3efd-75dd-a53c-40679aa4e74b.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=9191309365621035853&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "optumrx-fulfillment",
      "poi_latitude": "38.9190643",
      "poi_longitude": "-94.662952",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 7 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/019fc98b-c814-7312-ad90-ce1a2e842eda.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98b-c814-7312-ad90-ce1a2e842eda",
        "storage_key": "property/6767906449167609/019fc98b-c814-7312-ad90-ce1a2e842eda.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJOSlrPD_qwIcRTROQnisXjn8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_69a36920-c02b-4a87-a318-1c2db5e5558c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "source": "custom",
      "poi_name": "Blue Valley Schools",
      "poi_type": "Education",
      "poi_address": "15020 Metcalf Ave, Overland Park, KS 66223, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/019ff6ae-02d2-72c0-94b3-a57331c02cf9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6ae-02d2-72c0-94b3-a57331c02cf9",
        "storage_key": "property/6767906449167609/019ff6ae-02d2-72c0-94b3-a57331c02cf9.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.bluevalleyk12.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3950309088430247243&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "blue-valley-schools",
      "poi_latitude": "38.8561923",
      "poi_longitude": "-94.6681349",
      "poi_miles_from_property": "9.6",
      "poi_walking_minutes": "3 hours 35 mins",
      "poi_biking_minutes": "59 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 913-239-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/019fc985-a5cc-704b-a88b-33e77fb60140.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc985-a5cc-704b-a88b-33e77fb60140",
        "storage_key": "property/6767906449167609/019fc985-a5cc-704b-a88b-33e77fb60140.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJUbpZ95fqwIcRS83hsC9R0jY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    }
  ],
  "office_hours": [
    {
      "id": "ec_5cbe175f3c9f31349430e814",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "day": "MON",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_30bd0622e5e34df5a9ebbec2",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "day": "TUE",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_b8617dd4eff1413c3993f6f6",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "day": "WED",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_58a89da9a790299c616ea0fe",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "day": "THU",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_e66c36859bd8082da76cd838",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "day": "FRI",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_2487487fa9a919ac3936c42f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_768be48b5fe6b155cba9cf6c",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "rating": "5",
      "name": "Kelly Ann",
      "text": "We were panicking a bit because the lease on our current residence was terminated out of the blue due to the house being sold.  We came to Sheridan Ridge looking for something large enough to fit what we have in a three bedroom house.  We've found it here. Nidia was very informative during the tour and was great to work with during the leasing process.  She's been very communicative and her follow through is A+. I'm happy to have found a nice place on short notice.",
      "date": "2026-04-07",
      "title": "false"
    },
    {
      "id": "ec_db84dd40b068fd12d553602b",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "rating": "5",
      "name": "Bryce Presley",
      "text": "Nidia just gave us our tour and it was a great experience! She was thorough, friendly, and answered all our questions. The complex seems clean, quiet, and happy. Every unit we toured was clean and put together, we were shown all the amenities, and will likely be moving here! Highly recommend",
      "date": "2026-02-27",
      "title": "false"
    },
    {
      "id": "ec_4e956b95a4f077a3cacd06f2",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "rating": "5",
      "name": "Makala Ambler",
      "text": "I have lived at Sheridan Ridge for over 3 years. I love the townhomes and maintenance and office staff are amazing! I just recently transferred to a bigger townhome on site, and they all helped me tremendously! They have made this a smooth and easy move even during the Holiday season! I love it here! Thank you all so much!",
      "date": "2026-01-12",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_f4d383204c86bc0944b8aeb4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/01a0b65f-b687-779e-976e-86bf684ca0dc.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0b65f-b687-779e-976e-86bf684ca0dc",
        "storage_key": "property/6767906449167609/01a0b65f-b687-779e-976e-86bf684ca0dc.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Amber",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=Stak66ynAxF"
    },
    {
      "id": "ec_ad1e9b47e822b65080be494f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/01a0b65f-b431-707d-bb85-90a1b5884c96.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0b65f-b431-707d-bb85-90a1b5884c96",
        "storage_key": "property/6767906449167609/01a0b65f-b431-707d-bb85-90a1b5884c96.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Emerald",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=fhYE9kvHjLt"
    },
    {
      "id": "ec_f9c10e25e0c4f1f3320041d9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/01a0b65f-bb3e-71e3-9250-d1b96ae856ac.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0b65f-bb3e-71e3-9250-d1b96ae856ac",
        "storage_key": "property/6767906449167609/01a0b65f-bb3e-71e3-9250-d1b96ae856ac.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Onyx",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=Df75bP7Fuib"
    },
    {
      "id": "ec_581ff11655e92c8bafc51c57",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167609/01a0b65f-b2d9-73d7-94cf-7c10cab54cd6.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0b65f-b2d9-73d7-94cf-7c10cab54cd6",
        "storage_key": "property/6767906449167609/01a0b65f-b2d9-73d7-94cf-7c10cab54cd6.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Emerald (Renovated)",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=pS8RPBdgXoF"
    }
  ],
  "faqs": [
    {
      "id": "custom_99dfe5f2-9a2e-4082-8e3f-f1165e90676d",
      "question": "What are the qualifications for occupancy?",
      "answer": "Check our occupancy qualifications <a href=\"https://www.pricebrotherskc.com/ResidentialRentalQualifications/\">here</a>. We encourage everyone to apply, and hope to have you as a part of our community!",
      "category": "Rental Qualifications",
      "source": "custom"
    },
    {
      "id": "custom_49d47f71-cf39-4b8a-988a-8f5465384248",
      "question": "What is the application fee and is it refundable?",
      "answer": "Application fees are due for each person 18 and older occupying the apartment. All application fees are nonrefundable.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_968501e4-98ac-4bdc-8ae0-9bb3d1ddb2c1",
      "question": "How do I apply?",
      "answer": "Click on the <a href=\"/apply-now\">Apply Now</a> button under the <a href=\"/floor-plans\">Floor Plans</a> tab of our community website.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_05315427-b190-4acb-a9f1-0d4e3b20ce48",
      "question": "What is a holding deposit or earnest money?",
      "answer": "A \"holding\" deposit or \"earnest money\" is another word for \"security\" deposit. Please <a href=\"/contact-us\">contact our leasing office</a> for more details.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_d6e711dc-92cc-4a4a-88f7-f644b70e778b",
      "question": "Are there different lease term options available?",
      "answer": "Yes, we offer various lease term options. Please <a href=\"/contact-us\">contact our office</a> for more details.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_23d84e88-0b7d-4d27-afad-313ce13435fb",
      "question": "Do I need an appointment to take a tour?",
      "answer": "No appointment is necessary to tour our community during business hours; however, it is always appreciated if you call ahead to make sure we are available to provide adequate time for you to tour and ask questions. It is recommended to arrive no later than one half hour prior to closing if you would like to tour the community. Everyone over 18 years of age must have a valid photo ID to tour. Valid forms of identification are decided by Price Brothers Management Company and may include items such as: US Driver’s License, US State Photo ID, US Military Photo ID, US Visa with Photo ID upon it, US Citizenship and Immigration Services Photo ID, Passport.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_805b1099-1a59-4835-ab57-1c05b1f10200",
      "question": "Do you allow pets?",
      "answer": "Our community is happy to accept cats and dogs. Please refer to our pet section on the <a href=\"/pet-policy\">Pet Policy</a> page.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_4b99b57b-06d3-47e7-8e7e-64ea48be287f",
      "question": "What utilities am I responsible to pay?",
      "answer": "Our residents are responsible to pay for water, trash, electric and gas.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_4a122bd6-ff2d-46f0-a64a-4b4bb167fceb",
      "question": "Why does your pricing include ranges?",
      "answer": "The prices will range on each floor plan depending on finishes, views, and other features inside the apartment home.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_d65ca3f0-8203-4431-9821-2fecca9ff794",
      "question": "Do you require renters insurance?",
      "answer": "All residents are required to maintain a minimum of $100,000 in liability coverage as part of their lease agreement. For more details on coverage requirements and available options, please <a href=\"/contact-us\">contact our leasing office</a>.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_d28d84a6-de69-4878-9aca-9f30c7ff508c",
      "question": "How can I refer a friend?",
      "answer": "If you love living here and want to refer a friend, please let our office know! We offer resident referral programs throughout the year and would love for your friends and family to join our community.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_53553eb7-9d65-4726-878a-63aac249806b",
      "question": "How can I pay my rent?",
      "answer": "You can pay rent by accessing your <a href=\"/resident-access\">resident online account</a>. This allows you to use a bank account or credit card to make payments.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_2413ee36-50e8-4d9a-bcc9-5fadcf345b48",
      "question": "Do you offer covered parking?",
      "answer": "Yes, we offer carports. Please <a href=\"/contact-us\">contact the office</a> for our most current carport availability and pricing.",
      "category": "Amenities",
      "source": "custom"
    },
    {
      "id": "custom_5adb224d-2f77-41d3-964f-a24f53c09c2b",
      "question": "Do you host events at your property?",
      "answer": "Yes, we host events throughout the year with various activities to encourage community camaraderie.",
      "category": "Amenities",
      "source": "custom"
    },
    {
      "id": "custom_394f4b49-360b-4e80-b702-28a09aec7fa8",
      "question": "If something needs to be repaired in my apartment, how do I report it?",
      "answer": "You may call the office or submit work orders online by accessing your <a href=\"/resident-access\">resident account</a>. All emergency repairs should be reported by <a href=\"/contact-us\">contacting the office</a>. If the emergency is being reported after business hours, please follow the prompts to be connected to the answering service.",
      "category": "Maintenance",
      "source": "custom"
    },
    {
      "id": "custom_1666bed9-be8a-4084-a6d9-954f5a0a90ae",
      "question": "Do you accept packages on behalf of the residents?",
      "answer": "No, we do not offer this service at this time.",
      "category": "Maintenance",
      "source": "custom"
    }
  ],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "01a0c9ac-3f7d-73d3-8a49-237146ae7370",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "Sheridan Ridge Townhomes Property Website",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609"
    },
    {
      "lead_collector_id": "01a0c9ac-3fee-764a-bfb8-d571b1b4f854",
      "lead_source": "LANDING_PAGE",
      "name": "Sheridan Ridge Townhomes Landing Page",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "source": "generator",
      "page_item_url": "townhomes-with-pool-overland-park-ks",
      "search_query": "townhomes with pool Overland Park KS",
      "category": "Amenity",
      "h1_title": "Townhomes with Pool in Overland Park, KS",
      "h2_subtitle": "Discover townhomes with a pool nestled in Overland Park, KS. Enjoy community amenities at Sheridan Ridge Townhomes.",
      "page_copy": "Looking for townhomes with pool in Overland Park, KS? Discover Sheridan Ridge Townhomes, where relaxation is just outside your door. With a refreshing pool, you can enjoy summer days lounging or swimming, all within the vibrant area of Overland Park. This community offers space and comfort with its spacious two- and three-bedroom layouts, ensuring you have ample room to spread out.\n\nLocated near Concorde Bridge, our townhomes provide convenient access to local favorites and everyday essentials. Just off I-35, Sheridan Ridge is perfectly situated for easy commuting while maintaining a serene residential atmosphere. Our amenities, including carports and private patios, enhance your living experience, making Sheridan Ridge the ideal place to call home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167609/019fc986-6aee-747c-bc0d-1b16afb5b647.webp",
      "featured_image_media": {
        "alt_text": "An inviting outdoor swimming pool with lounge chairs and a building in the background under a colorful sunset sky.",
        "public_id": "019fc986-6aee-747c-bc0d-1b16afb5b647",
        "storage_key": "property/6767906449167609/019fc986-6aee-747c-bc0d-1b16afb5b647.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Townhomes with Pool in Overland Park, KS",
      "seo_description": "Experience townhomes with a pool in Overland Park, KS. Sheridan Ridge offers spacious layouts and convenient amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "source": "generator",
      "page_item_url": "apartments-with-in-unit-laundry-johnson-county",
      "search_query": "apartments with in-unit laundry Johnson County",
      "category": "Amenity",
      "h1_title": "Apartments with In-Unit Laundry in Johnson County",
      "h2_subtitle": "Discover apartments featuring in-unit laundry in Johnson County. Sheridan Ridge Townhomes offers all the comforts you need.",
      "page_copy": "Looking for apartments with in-unit laundry in Johnson County? Sheridan Ridge Townhomes brings convenience right to your doorstep by offering washer/dryer hookups in each townhome. Enjoy the comfort of doing laundry at home along with the spacious layouts of our two- and three-bedroom floor plans, designed to cater to your lifestyle needs.\n\nLocated near Concorde Bridge in Overland Park, KS, Sheridan Ridge is positioned for easy access to both everyday conveniences and local favorites. Live comfortably in our community with amenities like a pool and private patios that add value to your living experience. Enjoy the best of Johnson County living with these effortless conveniences.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167609/019fc986-6aee-747c-bc0d-1b16afb5b647.webp",
      "featured_image_media": {
        "alt_text": "An inviting outdoor swimming pool with lounge chairs and a building in the background under a colorful sunset sky.",
        "public_id": "019fc986-6aee-747c-bc0d-1b16afb5b647",
        "storage_key": "property/6767906449167609/019fc986-6aee-747c-bc0d-1b16afb5b647.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with In-Unit Laundry, Johnson County",
      "seo_description": "Find apartments with in-unit laundry in Johnson County. Sheridan Ridge Townhomes offers spacious living with washer/dryer hookups.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "source": "generator",
      "page_item_url": "air-conditioned-townhomes-concorde-bridge",
      "search_query": "air conditioned townhomes Concorde Bridge",
      "category": "Amenity",
      "h1_title": "Air Conditioned Townhomes at Concorde Bridge",
      "h2_subtitle": "Explore air conditioned townhomes near Concorde Bridge. Experience comfort at Sheridan Ridge Townhomes in Overland Park.",
      "page_copy": "Searching for air conditioned townhomes near Concorde Bridge? Located in the heart of Overland Park, Sheridan Ridge Townhomes ensures a cool and comfortable living environment year-round. Our townhomes provide the optimal relief you need during the hot summer days while offering ample space with our two- and three-bedroom layouts.\n\nSheridan Ridge offers more than just air conditioning; it provides easy access to I-35 and proximity to local favorites and conveniences. Enjoy features such as private patios and finished basements that are perfect for working or relaxing. Make the most of community living with our amenities, including a pool, which complements the comfortable, air-conditioned interiors.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167609/019fc986-6aee-747c-bc0d-1b16afb5b647.webp",
      "featured_image_media": {
        "alt_text": "An inviting outdoor swimming pool with lounge chairs and a building in the background under a colorful sunset sky.",
        "public_id": "019fc986-6aee-747c-bc0d-1b16afb5b647",
        "storage_key": "property/6767906449167609/019fc986-6aee-747c-bc0d-1b16afb5b647.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Air Conditioned Townhomes at Concorde Bridge",
      "seo_description": "Stay cool in air conditioned townhomes near Concorde Bridge. Find comfort and convenience at Sheridan Ridge, Overland Park.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "source": "generator",
      "page_item_url": "overland-park-ks-townhomes-with-dishwasher",
      "search_query": "Overland Park KS townhomes with dishwasher",
      "category": "Amenity",
      "h1_title": "Overland Park, KS Townhomes with Dishwasher",
      "h2_subtitle": "Discover townhomes in Overland Park, KS, complete with dishwashers. Sheridan Ridge offers comfort and convenience.",
      "page_copy": "For those seeking townhomes with a dishwasher in Overland Park, KS, Sheridan Ridge Townhomes is the perfect choice. Each of our spacious two- and three-bedroom townhomes includes a kitchen equipped with a dishwasher, making meal cleanup a breeze. Located near Concorde Bridge, our community offers the perfect blend of comfort and convenience.\n\nSheridan Ridge Townhomes is strategically positioned just off I-35, providing quick access to both local attractions and essential services. Enhance your living experience with amenities like private patios and a swimming pool, all set in a friendly neighborhood atmosphere. Experience the ideal balance of modern convenience and community charm.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167609/019fc986-6aee-747c-bc0d-1b16afb5b647.webp",
      "featured_image_media": {
        "alt_text": "An inviting outdoor swimming pool with lounge chairs and a building in the background under a colorful sunset sky.",
        "public_id": "019fc986-6aee-747c-bc0d-1b16afb5b647",
        "storage_key": "property/6767906449167609/019fc986-6aee-747c-bc0d-1b16afb5b647.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Overland Park Townhomes with Dishwasher",
      "seo_description": "Discover townhomes with a dishwasher in Overland Park, KS. Enjoy comfort and convenience at Sheridan Ridge Townhomes.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "source": "generator",
      "page_item_url": "spacious-townhomes-with-private-patio-66212",
      "search_query": "spacious townhomes with private patio 66212",
      "category": "Amenity",
      "h1_title": "Spacious Townhomes with Private Patios in 66212",
      "h2_subtitle": "Explore spacious townhomes in the 66212 area, featuring private patios. Sheridan Ridge Townhomes offers the perfect blend of comfort and outdoor space.",
      "page_copy": "Are you in search of spacious townhomes with private patios in the 66212 area? Sheridan Ridge Townhomes promises ample room to spread out, with options for two- and three-bedroom designs. Each townhome comes with a private patio, offering a serene outdoor retreat ideal for relaxation or entertaining guests.\n\nSituated in the vibrant neighborhood of Overland Park, KS, enjoy the convenience of living near Concorde Bridge and close to local parks and shopping. Our community offers easy access to I-35, making it simple to explore all that the city has to offer. Experience added comforts with amenities such as carports and a pool, enhancing your living experience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167609/019fc986-6aee-747c-bc0d-1b16afb5b647.webp",
      "featured_image_media": {
        "alt_text": "An inviting outdoor swimming pool with lounge chairs and a building in the background under a colorful sunset sky.",
        "public_id": "019fc986-6aee-747c-bc0d-1b16afb5b647",
        "storage_key": "property/6767906449167609/019fc986-6aee-747c-bc0d-1b16afb5b647.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Spacious Townhomes with Private Patios, 66212",
      "seo_description": "Find spacious townhomes featuring private patios in the 66212 area. Discover comfort and style at Sheridan Ridge Townhomes.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "source": "generator",
      "page_item_url": "two-bedroom-townhomes-overland-park-ks",
      "search_query": "two bedroom townhomes overland park ks",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Townhomes in Overland Park, KS",
      "h2_subtitle": "Explore two bedroom townhomes available in Overland Park, KS. Sheridan Ridge Townhomes provides the perfect blend of space and location.",
      "page_copy": "Looking for two bedroom townhomes in Overland Park, KS? Sheridan Ridge Townhomes offers spacious, well-appointed two-bedroom layouts that perfectly accommodate a modern lifestyle. Designed with comfort in mind, our townhomes feature generous closets and private patios, ideal for any living requirement.\n\nLocated just off I-35 near Concorde Bridge, our community offers the convenience of city living with suburban tranquility. Enjoy all the additional amenities that make Sheridan Ridge special—from our refreshing pool to the practical carports. Make Sheridan Ridge Townhomes your new home and experience the best of Overland Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167609/019fc986-6aee-747c-bc0d-1b16afb5b647.webp",
      "featured_image_media": {
        "alt_text": "An inviting outdoor swimming pool with lounge chairs and a building in the background under a colorful sunset sky.",
        "public_id": "019fc986-6aee-747c-bc0d-1b16afb5b647",
        "storage_key": "property/6767906449167609/019fc986-6aee-747c-bc0d-1b16afb5b647.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Townhomes in Overland Park, KS",
      "seo_description": "Discover two bedroom townhomes in Overland Park, KS. Enjoy spacious living at Sheridan Ridge with convenient amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "source": "generator",
      "page_item_url": "three-bedroom-townhomes-johnson-county",
      "search_query": "three bedroom townhomes johnson county",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Townhomes in Johnson County",
      "h2_subtitle": "Discover three bedroom townhomes available in Johnson County. Sheridan Ridge offers spacious living in a prime location.",
      "page_copy": "For families and individuals seeking three bedroom townhomes in Johnson County, Sheridan Ridge Townhomes provides the ideal living solution. Our spacious layouts feature finished basements and private patios, offering ample space for relaxation and hosting guests. Nestled in the vibrant area of Overland Park, KS, our community ensures you are never far from local highlights.\n\nSheridan Ridge is conveniently located near major highways, including I-35, giving residents quick access to nearby shopping, dining, and entertainment options. Additionally, enjoy modern amenities such as a swimming pool and carports, which add to the comfort and convenience of life here. Choose Sheridan Ridge Townhomes, where Johnson County living meets modern style.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167609/019fc986-6aee-747c-bc0d-1b16afb5b647.webp",
      "featured_image_media": {
        "alt_text": "An inviting outdoor swimming pool with lounge chairs and a building in the background under a colorful sunset sky.",
        "public_id": "019fc986-6aee-747c-bc0d-1b16afb5b647",
        "storage_key": "property/6767906449167609/019fc986-6aee-747c-bc0d-1b16afb5b647.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Townhomes in Johnson County",
      "seo_description": "Explore spacious three bedroom townhomes in Johnson County. Enjoy modern amenities and comfort at Sheridan Ridge Townhomes.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "source": "generator",
      "page_item_url": "townhomes-near-apache-elementary-overland-park",
      "search_query": "townhomes near apache elementary school overland park",
      "category": "School",
      "h1_title": "Townhomes Near Apache Elementary, Overland Park",
      "h2_subtitle": "Find townhomes close to Apache Elementary in Overland Park. Sheridan Ridge Townhomes offer ideal living for families and professionals.",
      "page_copy": "Searching for townhomes near Apache Elementary School in Overland Park? Sheridan Ridge Townhomes provides an exceptional location with two- and three-bedroom layouts that accommodate every lifestyle. Our community offers finished basements and private patios, creating a welcoming environment for you and your family.\n\nLocated just off I-35, Sheridan Ridge is perfectly positioned for easy access to Overland Park's attractions while being in close proximity to top-rated schools like Apache Elementary. Enjoy our community features such as a sparkling pool and carports, designed to enhance your living experience. Experience the convenience and comfort of Sheridan Ridge Townhomes, the ideal spot for families seeking excellence in Overland Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167609/019fc986-6aee-747c-bc0d-1b16afb5b647.webp",
      "featured_image_media": {
        "alt_text": "An inviting outdoor swimming pool with lounge chairs and a building in the background under a colorful sunset sky.",
        "public_id": "019fc986-6aee-747c-bc0d-1b16afb5b647",
        "storage_key": "property/6767906449167609/019fc986-6aee-747c-bc0d-1b16afb5b647.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Townhomes Near Apache Elementary, Overland Park",
      "seo_description": "Explore townhomes near Apache Elementary School in Overland Park. Sheridan Ridge offers family-friendly living with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "source": "generator",
      "page_item_url": "apartments-close-to-westridge-middle-school",
      "search_query": "apartments close to westridge middle school concorde bridge",
      "category": "School",
      "h1_title": "Apartments Near Westridge Middle School",
      "h2_subtitle": "Discover apartments close to Westridge Middle School in the Concorde Bridge area. Sheridan Ridge Townhomes offers the perfect family-friendly location.",
      "page_copy": "If you're searching for apartments close to Westridge Middle School in the Concorde Bridge area, look no further than Sheridan Ridge Townhomes. Our spacious townhomes feature two- and three-bedroom layouts, complete with finished basements and private patios, ensuring a comfortable and versatile living space for the whole family.\n\nConveniently located near I-35, Sheridan Ridge Townhomes offers easy access to local attractions around Overland Park while being just a short drive from Westridge Middle School. Make the most of community amenities such as a refreshing pool and covered parking, enhancing the convenience and appeal of your new home. Choose Sheridan Ridge for an ideal family living experience near top-rated educational institutions.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167609/019fc986-6aee-747c-bc0d-1b16afb5b647.webp",
      "featured_image_media": {
        "alt_text": "An inviting outdoor swimming pool with lounge chairs and a building in the background under a colorful sunset sky.",
        "public_id": "019fc986-6aee-747c-bc0d-1b16afb5b647",
        "storage_key": "property/6767906449167609/019fc986-6aee-747c-bc0d-1b16afb5b647.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Westridge Middle School",
      "seo_description": "Explore apartments near Westridge Middle School in Concorde Bridge. Enjoy spacious townhomes with modern amenities at Sheridan Ridge.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "source": "generator",
      "page_item_url": "sheridan-ridge-townhomes-near-shawnee-mission-west",
      "search_query": "sheridan ridge townhomes near shawnee mission west high",
      "category": "School",
      "h1_title": "Sheridan Ridge Townhomes by Shawnee Mission West",
      "h2_subtitle": "Discover Sheridan Ridge Townhomes near Shawnee Mission West High School. Enjoy family-friendly living in Overland Park.",
      "page_copy": "Located just minutes from Shawnee Mission West High School, Sheridan Ridge Townhomes in Overland Park offers the perfect blend of convenience and comfort. Our community features spacious two- and three-bedroom townhomes with private patios, finished basements, and ample storage to accommodate every aspect of family life.\n\nSheridan Ridge Townhomes provides easy access to Overland Park’s best attractions and top-rated schools, ensuring you stay connected to everything you need. Enjoy the convenience of amenities like a sparkling pool and covered parking, making life simpler and more enjoyable. Experience the best of townhome living at Sheridan Ridge, ideally located near Shawnee Mission West High School.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167609/019fc986-6aee-747c-bc0d-1b16afb5b647.webp",
      "featured_image_media": {
        "alt_text": "An inviting outdoor swimming pool with lounge chairs and a building in the background under a colorful sunset sky.",
        "public_id": "019fc986-6aee-747c-bc0d-1b16afb5b647",
        "storage_key": "property/6767906449167609/019fc986-6aee-747c-bc0d-1b16afb5b647.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Sheridan Ridge Near Shawnee Mission West",
      "seo_description": "Explore Sheridan Ridge Townhomes near Shawnee Mission West High School. Enjoy spacious living with modern amenities in Overland Park.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "source": "generator",
      "page_item_url": "townhomes-near-oak-park-carpenter-elementary-ks",
      "search_query": "townhomes near oak park-carpenter elementary school ks",
      "category": "School",
      "h1_title": "Townhomes Close to Oak Park-Carpenter Elementary",
      "h2_subtitle": "Discover townhomes near Oak Park-Carpenter Elementary in KS. Sheridan Ridge offers an ideal family-friendly location in Overland Park.",
      "page_copy": "For those seeking townhomes near Oak Park-Carpenter Elementary School in KS, Sheridan Ridge Townhomes provide a wonderful solution. Our spacious two- and three-bedroom homes include finished basements and private patios, offering ample room for family activities and relaxation.\n\nSituated just off I-35, Sheridan Ridge Townhomes allow easy access to Overland Park's attractions and are conveniently located near Oak Park-Carpenter Elementary. Residents can enjoy community amenities such as a refreshing pool and available carports, enhancing the appeal of our lovely townhomes. Choose Sheridan Ridge for a comfortable and connected living experience near excellent educational facilities.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167609/019fc986-6aee-747c-bc0d-1b16afb5b647.webp",
      "featured_image_media": {
        "alt_text": "An inviting outdoor swimming pool with lounge chairs and a building in the background under a colorful sunset sky.",
        "public_id": "019fc986-6aee-747c-bc0d-1b16afb5b647",
        "storage_key": "property/6767906449167609/019fc986-6aee-747c-bc0d-1b16afb5b647.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Townhomes Close to Oak Park-Carpenter Elementary",
      "seo_description": "Explore townhomes near Oak Park-Carpenter Elementary in KS. Sheridan Ridge offers spacious living with modern amenities in Overland Park.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "source": "generator",
      "page_item_url": "apartments-close-to-overland-park-elementary",
      "search_query": "apartments close to overland park elementary school",
      "category": "School",
      "h1_title": "Apartments Near Overland Park Elementary",
      "h2_subtitle": "Explore apartments close to Overland Park Elementary School. Sheridan Ridge Townhomes offers family-friendly living in Overland Park.",
      "page_copy": "When looking for apartments close to Overland Park Elementary School, Sheridan Ridge Townhomes emerges as a premier choice. Our townhomes feature spacious two- and three-bedroom layouts, complete with finished basements and private patios, providing ideal living spaces for families.\n\nSheridan Ridge Townhomes is conveniently located just off I-35, ensuring quick access to both Overland Park Elementary School and the city’s vibrant offerings. With amenities including a glistening pool and covered parking, we offer a wonderful blend of convenience and comfort. Choose Sheridan Ridge Townhomes for a welcoming community in a prime educational district.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167609/019fc986-6aee-747c-bc0d-1b16afb5b647.webp",
      "featured_image_media": {
        "alt_text": "An inviting outdoor swimming pool with lounge chairs and a building in the background under a colorful sunset sky.",
        "public_id": "019fc986-6aee-747c-bc0d-1b16afb5b647",
        "storage_key": "property/6767906449167609/019fc986-6aee-747c-bc0d-1b16afb5b647.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Overland Park Elementary",
      "seo_description": "Explore spacious Sheridan Ridge Townhomes situated near Overland Park Elementary School, offering modern amenities and convenient living in Overland Park.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "source": "generator",
      "page_item_url": "sheridan-ridge-near-overland-christian-school",
      "search_query": "sheridan ridge near overland christian school",
      "category": "School",
      "h1_title": "Sheridan Ridge by Overland Christian School",
      "h2_subtitle": "Find Sheridan Ridge Townhomes near Overland Christian School. Enjoy spacious living in a great Overland Park location.",
      "page_copy": "Sheridan Ridge Townhomes are ideally situated near Overland Christian School, offering a perfect setting for families seeking both convenience and comfort. Our expansive two- and three-bedroom townhomes feature finished basements, private patios, and ample storage, making it easy to accommodate family life.\n\nWith quick access to I-35, Sheridan Ridge Townhomes connect you effortlessly to Overland Park's attractions and esteemed educational facilities like Overland Christian School. Community perks such as a swimming pool and carports enhance your lifestyle, making this the ideal location for hassle-free, comfortable living. Experience quality townhome living at Sheridan Ridge, conveniently located close to Overland Christian School.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167609/019fc986-6aee-747c-bc0d-1b16afb5b647.webp",
      "featured_image_media": {
        "alt_text": "An inviting outdoor swimming pool with lounge chairs and a building in the background under a colorful sunset sky.",
        "public_id": "019fc986-6aee-747c-bc0d-1b16afb5b647",
        "storage_key": "property/6767906449167609/019fc986-6aee-747c-bc0d-1b16afb5b647.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Sheridan Ridge Near Overland Christian School",
      "seo_description": "Discover Sheridan Ridge Townhomes near Overland Christian School in Overland Park, featuring spacious living and family-friendly amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "source": "generator",
      "page_item_url": "apartments-near-johnson-county-community-college",
      "search_query": "apartments near johnson county community college",
      "category": "School",
      "h1_title": "Apartments Near Johnson County Community College",
      "h2_subtitle": "Explore Sheridan Ridge Townhomes near Johnson County Community College. Enjoy spacious living close to campus and Overland Park amenities.",
      "page_copy": "Looking for apartments near Johnson County Community College? Sheridan Ridge Townhomes provides an ideal residence with spacious two- and three-bedroom layouts, featuring finished basements and private patios for enhanced privacy and comfort. Located just off I-35, our townhomes offer easy access to the college, perfect for students and staff seeking convenience.\n\nSheridan Ridge Townhomes not only offers proximity to Johnson County Community College, but also to the attractions of Overland Park. Residents can benefit from amenities such as a swimming pool and available carport parking, ensuring a balanced and enjoyable living experience. Choose Sheridan Ridge for a well-located home with excellent facilities close to campus.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167609/019fc986-6aee-747c-bc0d-1b16afb5b647.webp",
      "featured_image_media": {
        "alt_text": "An inviting outdoor swimming pool with lounge chairs and a building in the background under a colorful sunset sky.",
        "public_id": "019fc986-6aee-747c-bc0d-1b16afb5b647",
        "storage_key": "property/6767906449167609/019fc986-6aee-747c-bc0d-1b16afb5b647.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Johnson County Community College",
      "seo_description": "Live close to Johnson County Community College in Sheridan Ridge Townhomes. Enjoy spacious living with easy access to Overland Park amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "source": "generator",
      "page_item_url": "townhomes-near-university-of-kansas-edwards-campus",
      "search_query": "townhomes near university of kansas edwards campus op",
      "category": "School",
      "h1_title": "Townhomes Near University of Kansas Edwards",
      "h2_subtitle": "Discover Sheridan Ridge Townhomes near University of Kansas Edwards Campus. Enjoy convenient and spacious living in Overland Park.",
      "page_copy": "For those seeking townhomes near University of Kansas Edwards Campus, Sheridan Ridge Townhomes offers an exceptional choice. With generous two- and three-bedroom layouts featuring finished basements and private patios, our townhomes cater to students and faculty looking for comfort and convenience.\n\nSituated just off I-35, Sheridan Ridge Townhomes ensures quick access to the University of Kansas Edwards Campus and Overland Park's vibrant community. Our amenities — which include a pool and carports — enhance the living experience, making Sheridan Ridge a top choice for those affiliated with the university seeking a lovely, practical home environment.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167609/019fc986-6aee-747c-bc0d-1b16afb5b647.webp",
      "featured_image_media": {
        "alt_text": "An inviting outdoor swimming pool with lounge chairs and a building in the background under a colorful sunset sky.",
        "public_id": "019fc986-6aee-747c-bc0d-1b16afb5b647",
        "storage_key": "property/6767906449167609/019fc986-6aee-747c-bc0d-1b16afb5b647.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Townhomes Near University of Kansas Edwards",
      "seo_description": "Choose Sheridan Ridge Townhomes near University of Kansas Edwards Campus in Overland Park. Enjoy spacious layouts and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "source": "generator",
      "page_item_url": "apartments-near-overland-park-regional-medical-center",
      "search_query": "apartments near Overland Park Regional Medical Center",
      "category": "Hospital",
      "h1_title": "Apartments Near Overland Park Regional Medical",
      "h2_subtitle": "Discover Sheridan Ridge Townhomes conveniently located near Overland Park Regional Medical Center. Experience comfortable living with easy accessibility.",
      "page_copy": "Sheridan Ridge Townhomes presents an excellent apartment option for those near Overland Park Regional Medical Center. Our spacious two- and three-bedroom townhomes feature finished basements, private patios, and generous closets, offering the ideal environment for both medical professionals and patients seeking short or long-term accommodation.\n\nLocated just off I-35, Sheridan Ridge combines convenience with a relaxed setting, providing seamless access to the Overland Park Regional Medical Center. Residents can enjoy on-site amenities like a pool and carports, enhancing their living experience. Opt for Sheridan Ridge Townhomes when you're seeking apartment living with proximity to healthcare facilities and city conveniences.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167609/019fc986-6aee-747c-bc0d-1b16afb5b647.webp",
      "featured_image_media": {
        "alt_text": "An inviting outdoor swimming pool with lounge chairs and a building in the background under a colorful sunset sky.",
        "public_id": "019fc986-6aee-747c-bc0d-1b16afb5b647",
        "storage_key": "property/6767906449167609/019fc986-6aee-747c-bc0d-1b16afb5b647.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Overland Park Regional Medical",
      "seo_description": "Find spacious living at Sheridan Ridge Townhomes near Overland Park Regional Medical Center. Benefit from easy access and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "source": "generator",
      "page_item_url": "townhomes-close-to-childrens-mercy-kansas-johnson-county",
      "search_query": "townhomes close to Children's Mercy Kansas Johnson County",
      "category": "Hospital",
      "h1_title": "Townhomes Close to Children's Mercy Kansas",
      "h2_subtitle": "Sheridan Ridge Townhomes is conveniently close to Children's Mercy Kansas in Johnson County, offering a welcoming and accessible living environment.",
      "page_copy": "Sheridan Ridge Townhomes provides an ideal living solution for those seeking townhomes close to Children's Mercy Kansas in Johnson County. Our community features spacious two- and three-bedroom options with finished basements and private patios, perfect for families and healthcare professionals alike.\n\nSituated nearby, Sheridan Ridge Townhomes ensures effortless access to Children's Mercy Kansas, making it easy for medical staff and families of patients. Alongside quick commutes, residents can enjoy amenities such as a swimming pool and carports, fostering a balanced lifestyle. Choose Sheridan Ridge for comfort and convenience right near essential healthcare services.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167609/019fc986-6aee-747c-bc0d-1b16afb5b647.webp",
      "featured_image_media": {
        "alt_text": "An inviting outdoor swimming pool with lounge chairs and a building in the background under a colorful sunset sky.",
        "public_id": "019fc986-6aee-747c-bc0d-1b16afb5b647",
        "storage_key": "property/6767906449167609/019fc986-6aee-747c-bc0d-1b16afb5b647.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Townhomes Close to Children's Mercy Kansas",
      "seo_description": "Live near Children's Mercy Kansas in Sheridan Ridge Townhomes. Spacious townhomes offering convenience and modern amenities in Johnson County.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "source": "generator",
      "page_item_url": "apartments-near-overland-park-arboretum-ks",
      "search_query": "apartments near Overland Park Arboretum KS",
      "category": "Park",
      "h1_title": "Apartments Near Overland Park Arboretum KS",
      "h2_subtitle": "Explore Sheridan Ridge Townhomes, situated conveniently near Overland Park Arboretum KS. Enjoy nature and modern living.",
      "page_copy": "Discover the perfect blend of nature and modern living at Sheridan Ridge Townhomes, conveniently located near Overland Park Arboretum KS. Our spacious two- and three-bedroom townhomes, complete with private patios, finished basements, and generous closets, offer a serene living option with easy access to one of Overland Park's natural gems.\n\nJust a short drive from the Overland Park Arboretum, Sheridan Ridge Townhomes provides a peaceful retreat with the convenience of city living. Enjoy our community's amenities such as a pool and carports, and relish in the tranquility of being close to expansive gardens and picturesque trails. Choose Sheridan Ridge for a harmonious balance of city and nature.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167609/019fc986-6aee-747c-bc0d-1b16afb5b647.webp",
      "featured_image_media": {
        "alt_text": "An inviting outdoor swimming pool with lounge chairs and a building in the background under a colorful sunset sky.",
        "public_id": "019fc986-6aee-747c-bc0d-1b16afb5b647",
        "storage_key": "property/6767906449167609/019fc986-6aee-747c-bc0d-1b16afb5b647.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Overland Park Arboretum KS",
      "seo_description": "Find tranquility at Sheridan Ridge Townhomes, near Overland Park Arboretum KS. Enjoy spacious living and easy access to nature.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "source": "generator",
      "page_item_url": "sheridan-ridge-townhomes-by-james-place-park",
      "search_query": "Sheridan Ridge townhomes by James Place Park",
      "category": "Park",
      "h1_title": "Sheridan Ridge Townhomes by James Place Park",
      "h2_subtitle": "Live at Sheridan Ridge Townhomes, conveniently located by James Place Park. Enjoy spacious layouts and vibrant surroundings.",
      "page_copy": "Sheridan Ridge Townhomes, nestled by the scenic James Place Park, offers residents a vibrant lifestyle in Overland Park. With spacious two- and three-bedroom layouts, featuring finished basements and private patios, these townhomes provide the comfort and convenience needed for modern living.\n\nJust a stone's throw from James Place Park, residents at Sheridan Ridge can revel in beautiful green spaces while benefiting from a community equipped with amenities such as a pool, carports, and in-unit washer/dryer hookups. Choose Sheridan Ridge Townhomes for a balanced life that combines nature, modern amenities, and exceptional proximity to local attractions.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167609/019fc986-6aee-747c-bc0d-1b16afb5b647.webp",
      "featured_image_media": {
        "alt_text": "An inviting outdoor swimming pool with lounge chairs and a building in the background under a colorful sunset sky.",
        "public_id": "019fc986-6aee-747c-bc0d-1b16afb5b647",
        "storage_key": "property/6767906449167609/019fc986-6aee-747c-bc0d-1b16afb5b647.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Sheridan Ridge Townhomes by James Place Park",
      "seo_description": "Experience comfort at Sheridan Ridge Townhomes, located by James Place Park. Enjoy spacious layouts and excellent amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "source": "generator",
      "page_item_url": "concorde-bridge-apartments-near-nall-hills-park",
      "search_query": "Concorde Bridge apartments near Nall Hills Park",
      "category": "Park",
      "h1_title": "Concorde Bridge Apartments Near Nall Hills Park",
      "h2_subtitle": "Discover Concorde Bridge apartments conveniently situated near Nall Hills Park. Enjoy a community that blends comfort and accessibility.",
      "page_copy": "Embrace a lifestyle of convenience at Sheridan Ridge Townhomes, located in the Concorde Bridge neighborhood and near Nall Hills Park. Our townhomes offer spacious two- and three-bedroom layouts with finished basements, perfect for those seeking plenty of room to spread out.\n\nAdjacent to the calming Nall Hills Park, residents can enjoy outdoor activities while living in stylish townhomes equipped with private patios, carports, and a refreshing pool. Choose Sheridan Ridge Townhomes for a unique setting that allows you to enjoy the best of nature and modern amenities within the Concorde Bridge neighborhood.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167609/019fc986-6aee-747c-bc0d-1b16afb5b647.webp",
      "featured_image_media": {
        "alt_text": "An inviting outdoor swimming pool with lounge chairs and a building in the background under a colorful sunset sky.",
        "public_id": "019fc986-6aee-747c-bc0d-1b16afb5b647",
        "storage_key": "property/6767906449167609/019fc986-6aee-747c-bc0d-1b16afb5b647.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Concorde Bridge Apartments Near Nall Hills Park",
      "seo_description": "Concorde Bridge apartments near Nall Hills Park offer spacious living at Sheridan Ridge Townhomes. Enjoy superb amenities and park proximity.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "source": "generator",
      "page_item_url": "townhomes-close-to-pinehurst-east-park-overland-park",
      "search_query": "townhomes close to Pinehurst East Park Overland Park",
      "category": "Park",
      "h1_title": "Townhomes Close to Pinehurst East Park",
      "h2_subtitle": "Sheridan Ridge Townhomes are ideally located close to Pinehurst East Park. Enjoy spacious layouts and a convenient location.",
      "page_copy": "Located just a short walk from Pinehurst East Park, Sheridan Ridge Townhomes offers a premium living experience in Overland Park. These spacious two- and three-bedroom townhomes provide a perfect mix of privacy and comfort, featuring finished basements and generous closets.\n\nResidents at Sheridan Ridge Townhomes can enjoy the close proximity to Pinehurst East Park, with its relaxing green spaces and recreational options. The community also boasts amenities like a swimming pool, carports, and kitchens with dishwashers, ensuring a modern living experience that is both convenient and enjoyable.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167609/019fc986-6aee-747c-bc0d-1b16afb5b647.webp",
      "featured_image_media": {
        "alt_text": "An inviting outdoor swimming pool with lounge chairs and a building in the background under a colorful sunset sky.",
        "public_id": "019fc986-6aee-747c-bc0d-1b16afb5b647",
        "storage_key": "property/6767906449167609/019fc986-6aee-747c-bc0d-1b16afb5b647.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Townhomes Close to Pinehurst East Park",
      "seo_description": "Live near Pinehurst East Park in Sheridan Ridge Townhomes, Overland Park. Spacious living with convenient amenities awaits you.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "source": "generator",
      "page_item_url": "johnson-county-apartments-by-indian-creek-recreation-center",
      "search_query": "Johnson County apartments by Indian Creek Recreation Center",
      "category": "Park",
      "h1_title": "Johnson County Apartments by Indian Creek Rec Center",
      "h2_subtitle": "Discover apartments in Johnson County, ideally located by Indian Creek Recreation Center. Enjoy spacious living and recreational opportunities.",
      "page_copy": "Nestled in Johnson County, Sheridan Ridge Townhomes offers exceptional living just a few minutes from the Indian Creek Recreation Center. These expansive two- and three-bedroom townhomes feature modern amenities, including finished basements and generous closets, ideal for comfortable living.\n\nSituated near the Indian Creek Recreation Center, residents can easily take advantage of a variety of recreational activities while enjoying the conveniences of Sheridan Ridge. With amenities like a refreshing pool, carports, and in-unit washer/dryer hookups, these townhomes provide the perfect blend of comfort and accessibility in Johnson County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167609/019fc986-6aee-747c-bc0d-1b16afb5b647.webp",
      "featured_image_media": {
        "alt_text": "An inviting outdoor swimming pool with lounge chairs and a building in the background under a colorful sunset sky.",
        "public_id": "019fc986-6aee-747c-bc0d-1b16afb5b647",
        "storage_key": "property/6767906449167609/019fc986-6aee-747c-bc0d-1b16afb5b647.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Johnson County Apartments by Indian Creek Rec Center",
      "seo_description": "Johnson County living at Sheridan Ridge Townhomes, near Indian Creek Recreation Center. Spacious layouts with great amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "source": "generator",
      "page_item_url": "apartment-living-near-cross-creek-park-ks",
      "search_query": "apartment living near Cross Creek Park KS",
      "category": "Park",
      "h1_title": "Apartment Living Near Cross Creek Park KS",
      "h2_subtitle": "Experience exceptional apartment living near Cross Creek Park KS. Enjoy spacious layouts and modern amenities at Sheridan Ridge Townhomes.",
      "page_copy": "Sheridan Ridge Townhomes offers a unique living experience near Cross Creek Park KS, combining comfortable living spaces with the beauty of nearby green areas. Our community features spacious two- and three-bedroom townhomes with finished basements, generous closets, and private patios.\n\nSet in a convenient location, residents can enjoy quick access to Cross Creek Park and its serene environment. With amenities such as a swimming pool, carports, and kitchens equipped with dishwashers, Sheridan Ridge Townhomes provides everything you need for modern apartment living in a vibrant community.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167609/019fc986-6aee-747c-bc0d-1b16afb5b647.webp",
      "featured_image_media": {
        "alt_text": "An inviting outdoor swimming pool with lounge chairs and a building in the background under a colorful sunset sky.",
        "public_id": "019fc986-6aee-747c-bc0d-1b16afb5b647",
        "storage_key": "property/6767906449167609/019fc986-6aee-747c-bc0d-1b16afb5b647.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartment Living Near Cross Creek Park KS",
      "seo_description": "Discover Sheridan Ridge Townhomes offering spacious living near Cross Creek Park KS. Enjoy modern amenities and a great community vibe.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "source": "generator",
      "page_item_url": "overland-park-townhomes-near-forest-creek-park",
      "search_query": "Overland Park townhomes near Forest Creek Park",
      "category": "Park",
      "h1_title": "Overland Park Townhomes Near Forest Creek Park",
      "h2_subtitle": "Find ideal townhomes in Overland Park near the tranquil Forest Creek Park. Enjoy spacious living with convenient amenities.",
      "page_copy": "Discover spacious living at Sheridan Ridge Townhomes, perfectly located close to Forest Creek Park in Overland Park. Our community offers two- and three-bedroom townhomes that feature finished basements, spacious closets, and private patios, creating a delightful living experience.\n\nResidents enjoy proximity to Forest Creek Park, allowing easy access to outdoor adventures and serene environments. Complemented by amenities such as a refreshing pool, carports, and modern kitchens with dishwasher facilities, these townhomes provide the perfect blend of comfort and convenience in Overland Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167609/019fc986-6aee-747c-bc0d-1b16afb5b647.webp",
      "featured_image_media": {
        "alt_text": "An inviting outdoor swimming pool with lounge chairs and a building in the background under a colorful sunset sky.",
        "public_id": "019fc986-6aee-747c-bc0d-1b16afb5b647",
        "storage_key": "property/6767906449167609/019fc986-6aee-747c-bc0d-1b16afb5b647.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Overland Park Townhomes Near Forest Creek Park",
      "seo_description": "Sheridan Ridge Townhomes offers spacious living near Forest Creek Park in Overland Park. Enjoy modern amenities in a convenient location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "source": "generator",
      "page_item_url": "sheridan-ridge-apartments-by-brookridge-park",
      "search_query": "Sheridan Ridge apartments by Brookridge Park",
      "category": "Park",
      "h1_title": "Sheridan Ridge Apartments by Brookridge Park",
      "h2_subtitle": "Explore Sheridan Ridge Apartments located near the beautiful Brookridge Park. Enjoy spacious layouts and a host of modern amenities.",
      "page_copy": "Sheridan Ridge Townhomes presents an exceptional living experience near Brookridge Park. Our two- and three-bedroom apartments offer spacious interiors with features like finished basements, ample closet space, and private patios, providing a perfect retreat for residents.\n\nLocated just a stone's throw from Brookridge Park, enjoy access to outdoors and park amenities while benefiting from the conveniences at Sheridan Ridge. With available amenities such as a swimming pool, carport parking, and kitchens equipped with dishwashers, our community ensures you have all you need for comfortable living by Brookridge Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167609/019fc986-6aee-747c-bc0d-1b16afb5b647.webp",
      "featured_image_media": {
        "alt_text": "An inviting outdoor swimming pool with lounge chairs and a building in the background under a colorful sunset sky.",
        "public_id": "019fc986-6aee-747c-bc0d-1b16afb5b647",
        "storage_key": "property/6767906449167609/019fc986-6aee-747c-bc0d-1b16afb5b647.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Sheridan Ridge Apartments by Brookridge Park",
      "seo_description": "Explore Sherdan Ridge Townhomes near Brookridge Park, featuring spacious apartments and modern amenities for ideal living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "source": "generator",
      "page_item_url": "overland-park-townhomes-close-to-strang-park",
      "search_query": "Overland Park townhomes close to Strang Park",
      "category": "Park",
      "h1_title": "Overland Park Townhomes Close to Strang Park",
      "h2_subtitle": "Find Overland Park townhomes located conveniently close to Strang Park. Enjoy modern amenities and spacious living spaces.",
      "page_copy": "Sheridan Ridge Townhomes, situated near Strang Park, offers a perfect blend of convenience and comfort. Our two- and three-bedroom townhomes provide ample living space with finished basements, generous closets, and private patios, making them ideal for families and individuals alike.\n\nLiving close to Strang Park means easy access to outdoor activities and beautiful parkland, right in the heart of Overland Park. Our community also boasts a refreshing swimming pool, carports, and well-equipped kitchens with dishwashers, ensuring that residents experience both practicality and leisure in their everyday lives.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167609/019fc986-6aee-747c-bc0d-1b16afb5b647.webp",
      "featured_image_media": {
        "alt_text": "An inviting outdoor swimming pool with lounge chairs and a building in the background under a colorful sunset sky.",
        "public_id": "019fc986-6aee-747c-bc0d-1b16afb5b647",
        "storage_key": "property/6767906449167609/019fc986-6aee-747c-bc0d-1b16afb5b647.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Overland Park Townhomes Close to Strang Park",
      "seo_description": "Sheridan Ridge Townhomes near Strang Park offer spacious living with modern amenities and a convenient Overland Park location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167609",
      "source": "generator",
      "page_item_url": "townhomes-near-kansas-city-airport-overland-park",
      "search_query": "townhomes near kansas city international airport overland park",
      "category": "Transit",
      "h1_title": "Townhomes Near Kansas City Airport, Overland Park",
      "h2_subtitle": "Discover townhomes in Overland Park near Kansas City International Airport. Experience spacious layouts and prime location.",
      "page_copy": "Located conveniently in Overland Park, Sheridan Ridge Townhomes offers spacious two- and three-bedroom options just a short drive from Kansas City International Airport. With features like finished basements, abundant closet space, and private patios, these townhomes are perfect for frequent travelers and families.\n\nResidents enjoy easy access to travel routes while living in a community boasting amenities such as a swimming pool, carports, and kitchens equipped with dishwashers. Sheridan Ridge Townhomes makes airport access seamless without sacrificing comfort and community in Overland Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167609/019fc986-6aee-747c-bc0d-1b16afb5b647.webp",
      "featured_image_media": {
        "alt_text": "An inviting outdoor swimming pool with lounge chairs and a building in the background under a colorful sunset sky.",
        "public_id": "019fc986-6aee-747c-bc0d-1b16afb5b647",
        "storage_key": "property/6767906449167609/019fc986-6aee-747c-bc0d-1b16afb5b647.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Townhomes Near Kansas City Airport, Overland Park",
      "seo_description": "Find Sheridan Ridge Townhomes near Kansas City International Airport in Overland Park. Enjoy spacious living and convenient amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "bobbi@repli360.com"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "12701886329"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-TTCJM64F"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Batch 9"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Rise"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_rentcafe_chatbot",
      "type": "STRING",
      "value": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/webchatjs/d51c594b-edea-43c3-8c37-c8a650431c42/app.js?nocache=1&gaTracking=G-0E08YYWKEP&buttonbgcolor=63513d&buttontextcolor=ffffff&chatheader=0&embed=false\"></script>"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "913-404-2768"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6InBVUXFLWmV6OC94MWlVN0JJZU1EWmc9PSIsInZhbHVlIjoiODBuZm9HU1BaRmphT0szUlZLOUJEUT09IiwibWFjIjoiYjhlODAxZWYxNTRhZjFkNmUzYTI5ZDhhY2NkNjgxNzNjZTZmYWMzYmViOGE1YzBiNWEzZjFlMDkwODBmYTM5OCJ9"
    }
  ],
  "custom_csm": "bobbi@repli360.com",
  "custom_repli_id": "12701886329",
  "custom_google_gtm_id": "GTM-TTCJM64F",
  "custom_rollout_phase": "Batch 9",
  "custom_vibesites_theme": "Rise",
  "custom_ads_subscription": "essential",
  "custom_rentcafe_chatbot": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/webchatjs/d51c594b-edea-43c3-8c37-c8a650431c42/app.js?nocache=1&gaTracking=G-0E08YYWKEP&buttonbgcolor=63513d&buttontextcolor=ffffff&chatheader=0&embed=false\"></script>",
  "custom_seo_subscription": "essential",
  "custom_social_subscription": "none",
  "custom_website_subscription": "turnkey",
  "custom_ppc_tracking_phone_number": "913-404-2768",
  "custom_apartmentsync_javascript_id": "eyJpdiI6InBVUXFLWmV6OC94MWlVN0JJZU1EWmc9PSIsInZhbHVlIjoiODBuZm9HU1BaRmphT0szUlZLOUJEUT09IiwibWFjIjoiYjhlODAxZWYxNTRhZjFkNmUzYTI5ZDhhY2NkNjgxNzNjZTZmYWMzYmViOGE1YzBiNWEzZjFlMDkwODBmYTM5OCJ9",
  "custom_audioeye_site_id": "5a21a2ce-a96c-4547-80f1-ded0337fe57c",
  "custom_audioeye_site_hash": "778e4a54ce62a504a308cb1d4d1be848"
};

export const generatedAt = '2026-11-03T22:58:20.678Z';
